import React from 'react';

const imgs = {
  closeIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="CloseCircleIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm5.735 8L16 13.735 10.265 8 8 10.265 13.735 16 8 21.735 10.265 24 16 18.265 21.735 24 24 21.735 18.265 16 24 10.265 21.735 8z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  supportLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="48"
      role="presentation"
      alt=""
      data-testid="SupportIcon"
      color="currentColor"
      size="48"
    >
      <path
        d="M28.126.862H3.876A3.904 3.904 0 0 0 0 4.757v17.838a3.905 3.905 0 0 0 3.875 3.896h8.375c.125 0 .125 0 .125.125l3.626 4.397a.122.122 0 0 0 .125.125c.125 0 .125 0 .25-.125L20 26.616a.122.122 0 0 1 .124-.125h8.001A3.904 3.904 0 0 0 32 22.595V4.757A3.903 3.903 0 0 0 28.126.862zM17.954 20.91a2.018 2.018 0 0 1-.438.64 2.062 2.062 0 0 1-1.446.58 2.092 2.092 0 0 1-.802-.154 1.944 1.944 0 0 1-.652-.43 1.98 1.98 0 0 1-.427-.642 2.119 2.119 0 0 1-.001-1.59 1.97 1.97 0 0 1 .43-.65 2.055 2.055 0 0 1 .643-.432 2.078 2.078 0 0 1 1.613 0 2.152 2.152 0 0 1 .64.428l.002.001a2.045 2.045 0 0 1 .438 2.25zm2.964-10.055a4.505 4.505 0 0 1-.662 1.159 5.04 5.04 0 0 1-.861.844l-.822.622a6.01 6.01 0 0 0-.626.538.766.766 0 0 0-.231.426l-.303 1.923h-2.517l-.222-2.13a1.824 1.824 0 0 1 .193-1.127 3.152 3.152 0 0 1 .648-.812 7.965 7.965 0 0 1 .838-.658 6.94 6.94 0 0 0 .782-.626 3.116 3.116 0 0 0 .574-.716 1.726 1.726 0 0 0 .208-.873 1.287 1.287 0 0 0-.112-.55 1.213 1.213 0 0 0-.318-.414 1.482 1.482 0 0 0-.506-.275 2.946 2.946 0 0 0-1.628.018 3.595 3.595 0 0 0-.666.277 8.824 8.824 0 0 0-.49.294.966.966 0 0 1-1.483-.33l-.872-1.378.24-.212a8 8 0 0 1 .86-.657 6.234 6.234 0 0 1 1.023-.55 6.4 6.4 0 0 1 1.192-.37 6.63 6.63 0 0 1 3.248.15 4.301 4.301 0 0 1 1.475.826 3.736 3.736 0 0 1 .966 1.314 4.161 4.161 0 0 1 .34 1.703 4.304 4.304 0 0 1-.268 1.584z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  heartLarge: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="StarBurstFilledIcon"
      color="currentColor"
      size="48"
    >
      <path
        d="M8.663 31.026a1.69 1.69 0 0 1-1.057-.344 2.25 2.25 0 0 1-.758-1.938c.062-1.324.248-2.64.555-3.929.253-1.211.542-2.4.737-3.17a84.512 84.512 0 0 1-2.512-2.156c-2.863-2.571-3.406-3.514-3.406-4.356 0-.192.034-.383.1-.564.36-.992 1.25-1.51 5.583-1.99a85 85 0 0 1 3.296-.29c.306-.737.788-1.87 1.316-3 1.823-3.906 2.648-4.593 3.706-4.593 1.06 0 1.883.687 3.692 4.592a83.727 83.727 0 0 1 1.303 2.995c.859.064 2.09.167 3.336.309 4.366.497 5.258 1.02 5.608 2l.003.01c.063.178.095.366.096.555 0 .836-.538 1.77-3.38 4.31a83.66 83.66 0 0 1-2.471 2.107c.198.79.492 2.008.746 3.236.304 1.289.49 2.602.552 3.925a2.187 2.187 0 0 1-.873 2.02c-.849.53-1.913.414-5.672-1.665a89.05 89.05 0 0 1-2.875-1.667 85.278 85.278 0 0 1-2.911 1.691c-2.416 1.33-3.782 1.912-4.714 1.912M30.737 5.879a.475.475 0 0 1-.081.664l-2.73 1.914a.475.475 0 0 1-.583-.747l2.73-1.913a.473.473 0 0 1 .664.082m-6.347-4.87a.475.475 0 0 1 .261.616L23.586 4.26a.473.473 0 0 1-.877-.354l1.065-2.635a.469.469 0 0 1 .615-.261M1.474 5.879a.475.475 0 0 0 .082.664l2.73 1.914a.474.474 0 0 0 .582-.747l-2.73-1.913a.474.474 0 0 0-.664.082m6.348-4.87a.474.474 0 0 0-.262.616L8.624 4.26a.474.474 0 0 0 .879-.354L8.438 1.27a.47.47 0 0 0-.254-.258.469.469 0 0 0-.362-.003M31.89 27.52a.475.475 0 0 1-.668.059l-2.176-1.826a.473.473 0 0 1 .609-.725l2.175 1.825a.473.473 0 0 1 .059.668M.11 27.52c.169.2.468.227.668.059l2.175-1.826a.474.474 0 0 0-.609-.725L.17 26.853a.476.476 0 0 0-.059.668"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  cardCodeLarge: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="GiftIcon"
      color="currentColor"
      size="48"
    >
      <g fill="currentColor">
        <path d="M12.151 13.21c.204 0 .406-.035.599-.1.73-.171 1.2-.882 1.073-1.621a1.25 1.25 0 0 0-1.236-.739c-.203 0-.406.035-.598.1a1.417 1.417 0 0 0-1.073 1.621c.214.483.709.779 1.235.739zm-4.561 0a1.247 1.247 0 0 0 1.235-.739 1.414 1.414 0 0 0-1.073-1.62 1.84 1.84 0 0 0-.598-.1 1.247 1.247 0 0 0-1.235.738 1.415 1.415 0 0 0 1.073 1.62c.192.066.394.1.598.1z"></path>
        <path d="M0 8.533v4.8h4.897c-.5-.664-.65-1.53-.4-2.324A2.724 2.724 0 0 1 7.154 9.25 3.257 3.257 0 0 1 9 9.817V5.333H3.2a3.197 3.197 0 0 0-3.2 3.2zm28.8-3.2H11v4.318a3.336 3.336 0 0 1 1.587-.401 2.724 2.724 0 0 1 2.657 1.76c.25.793.1 1.659-.4 2.323H32v-4.8a3.2 3.2 0 0 0-3.2-3.2zM14.52 16.908a.75.75 0 1 1-.91 1.192L11 16.106v10.56h17.8a3.196 3.196 0 0 0 3.2-3.199v-8.134H12.46l2.06 1.575zm-8.843 1.346a.749.749 0 0 1-.456-1.346l2.061-1.575H0v8.134a3.2 3.2 0 0 0 3.2 3.2H9V15.908L6.131 18.1c-.13.1-.29.154-.454.154z"></path>
      </g>
    </svg>
  ),
  orderStatus: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="ReceiptIcon"
      color="currentColor"
      size="48"
    >
      <path
        d="M26 1.6L24 0l-2 1.6L20 0l-2 1.6L16 0l-2 1.6L12 0l-2 1.6L8 0 6 1.6 4 0v30.4L6 32l2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6V0l-2 1.6zM8 6h8v2H8V6zm16 20H8v-2h16v2zm0-4H8v-2h16v2zm0-4H8v-2h16v2zm0-4H8v-2h16v2z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  filterIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      role="presentation"
      alt=""
      data-testid="FilterIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M28.5 3.5H3.641a2.598 2.598 0 0 0-2.602 2.052A2.502 2.502 0 0 0 3.5 8.5h24.837a2.609 2.609 0 0 0 2.66-2.387A2.496 2.496 0 0 0 28.5 3.5zm-4 10H7.641a2.598 2.598 0 0 0-2.602 2.052A2.502 2.502 0 0 0 7.5 18.5h16.837a2.609 2.609 0 0 0 2.66-2.387A2.496 2.496 0 0 0 24.5 13.5zm-4 10h-8.859a2.598 2.598 0 0 0-2.602 2.052A2.502 2.502 0 0 0 11.5 28.5h8.837a2.609 2.609 0 0 0 2.66-2.387A2.496 2.496 0 0 0 20.5 23.5z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  supportPlaymodesIcon: (
    <svg
      data-name="Switch lite"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="28"
      role="presentation"
      alt=""
      data-testid="SwitchLiteIcon"
      size="28"
      color="currentColor"
    >
      <path
        d="M28.737 9.41H3.262a3.218 3.218 0 0 0-3.218 3.218v7.164a3.218 3.218 0 0 0 3.218 3.218h25.475a3.218 3.218 0 0 0 3.219-3.218v-7.164a3.218 3.218 0 0 0-3.219-3.218zm.112 2.173a.563.563 0 1 1-.563.563.563.563 0 0 1 .563-.563zm0 2.32a.563.563 0 1 1-.563.564.563.563 0 0 1 .563-.563zM3.146 12.106a1.2 1.2 0 1 1-1.2 1.201 1.2 1.2 0 0 1 1.2-1.2zm1.437 5.85a.125.125 0 0 1-.125.125h-.731a.133.133 0 0 0-.133.134v.73a.126.126 0 0 1-.125.126h-.636a.125.125 0 0 1-.126-.126v-.73a.133.133 0 0 0-.132-.134h-.732a.125.125 0 0 1-.125-.125v-.636a.125.125 0 0 1 .125-.125h.732a.133.133 0 0 0 .132-.133v-.73a.125.125 0 0 1 .126-.126h.636a.126.126 0 0 1 .125.125v.731a.133.133 0 0 0 .133.133h.73a.125.125 0 0 1 .126.125zm1.674 3.654h19.497V10.82H6.257zm20.807-8.302a.563.563 0 1 1 .563.563.563.563 0 0 1-.563-.563zm1.778 5.532a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.2zm1.23-4.97a.563.563 0 1 1 .562-.562.563.563 0 0 1-.563.563z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  settingIconlarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="28"
      role="presentation"
      alt=""
      data-testid="GearIcon"
      size="28"
      color="currentColor"
    >
      <path
        d="M30.6 13.1h-2.4c-.3-1.4-.8-2.6-1.5-3.8l1.7-1.7c.5-.5.5-1.4 0-1.9l-2.1-2.1c-.5-.5-1.4-.5-1.9 0l-1.7 1.7c-1.2-.7-2.4-1.3-3.8-1.5V1.4c0-.7-.6-1.4-1.4-1.4h-3c-.7 0-1.4.6-1.4 1.4v2.4c-1.4.4-2.6.8-3.8 1.5L7.6 3.6c-.5-.5-1.4-.5-1.9 0L3.6 5.7c-.6.5-.6 1.4 0 1.9l1.7 1.7c-.7 1.2-1.3 2.4-1.5 3.8H1.3c-.7 0-1.4.6-1.4 1.4v3c0 .7.6 1.4 1.4 1.4h2.4c.3 1.4.8 2.6 1.5 3.8l-1.7 1.7c-.5.5-.5 1.4 0 1.9l2.1 2.1c.6.5 1.4.5 2 0l1.7-1.7c1.2.7 2.4 1.3 3.8 1.5v2.5c0 .7.6 1.4 1.4 1.4h3c.7 0 1.4-.6 1.4-1.4v-2.4c1.4-.3 2.6-.8 3.8-1.5l1.7 1.7c.5.5 1.4.5 1.9 0l2.1-2.1c.5-.5.5-1.4 0-1.9l-1.7-1.7c.7-1.2 1.3-2.4 1.5-3.8h2.4c.7 0 1.4-.6 1.4-1.4v-3c.1-.9-.6-1.5-1.4-1.5zM16 21.6c-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6 3.1 0 5.6 2.5 5.6 5.6-.1 3.1-2.6 5.6-5.6 5.6z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  publisherIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="28"
      role="presentation"
      alt=""
      data-testid="BuildingIcon"
      size="28"
      color="currentColor"
    >
      <path
        d="M28.9 2.1C28.9 1 28 0 26.8 0H5.6C4.4 0 3.5 1 3.5 2.1v29.8H12v-6.4h7.4v6.4h9.5V2.1zm-19 25.6H6.7v-3.2h3.2v3.2zm0-5.4H6.7v-3.2h3.2v3.2zm0-5.3H6.7v-3.2h3.2V17zm0-5.3H6.7V8.5h3.2v3.2zm0-5.3H6.7V3.2h3.2v3.2zm5.2 15.9H12v-3.2h3.2v3.2zm0-5.3H12v-3.2h3.2V17zm0-5.3H12V8.5h3.2v3.2zm0-5.3H12V3.2h3.2v3.2zm5.3 15.9h-3.2v-3.2h3.2v3.2zm0-5.3h-3.2v-3.2h3.2V17zm0-5.3h-3.2V8.5h3.2v3.2zm0-5.3h-3.2V3.2h3.2v3.2zm5.3 21.3h-3.2v-3.2h3.2v3.2zm0-5.4h-3.2v-3.2h3.2v3.2zm0-5.3h-3.2v-3.2h3.2V17zm0-5.3h-3.2V8.5h3.2v3.2zm0-5.3h-3.2V3.2h3.2v3.2z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  productGameIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="28"
      role="presentation"
      alt=""
      data-testid="DPadIcon"
      size="28"
      color="currentColor"
    >
      <path
        d="M30.1 10.4h-8.5V1.9c0-1-.8-1.9-1.9-1.9h-7.5c-1 0-1.9.8-1.9 1.9v8.5H1.9c-1 0-1.9.8-1.9 1.9v7.5c0 1 .8 1.9 1.9 1.9h8.5v8.5c0 1 .8 1.9 1.9 1.9h7.5c1 0 1.9-.8 1.9-1.9v-8.5h8.5c1 0 1.9-.8 1.9-1.9v-7.5c-.1-1.1-.9-1.9-2-1.9zM7.5 16.9H3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9s-.5.9-1 .9zm9.4 11.3c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.8zm0-20.7c0 .5-.4.9-.9.9s-.9-.4-.9-.9V3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.7zm11.3 9.4h-3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9.1.5-.3.9-.9.9z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  calendar: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="28"
      role="presentation"
      alt=""
      data-testid="CalendarIcon"
      size="28"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M21.8 19.1h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm0 8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm1.6-20.3h1.5c.5 0 .9-.4.9-.9v-5c0-.5-.4-.9-.9-.9h-1.5c-.5 0-.9.4-.9.9v5c0 .5.4.9.9.9zm-16.3 0h1.5c.5 0 .9-.4.9-.9v-5c0-.5-.4-.9-.9-.9H7.1c-.5 0-.9.4-.9.9v5c0 .5.4.9.9.9zm6.1 20.3h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9z"
      ></path>
      <path
        fill="currentColor"
        d="M29.5 4.3H27v2.2c0 1.2-.9 2.1-2.1 2.1h-1.5c-1.2 0-2.1-1-2.1-2.1V4.3H10.7v2.2c0 1.2-.9 2.1-2.1 2.1H7.1C5.9 8.6 5 7.6 5 6.5V4.3H2.5C1.1 4.3 0 5.4 0 6.7V29c0 1.4 1.1 2.5 2.5 2.5h27c1.4 0 2.5-1.1 2.5-2.5V6.7c0-1.3-1.1-2.4-2.5-2.4zm0 24.7h-27V10.4h27V29z"
      ></path>
      <path
        fill="currentColor"
        d="M13.2 19.1h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm-8.6 8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9H4.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm0-8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9H4.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9z"
      ></path>
    </svg>
  ),
  handHeld: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="HandheldModeIcon"
      size="48"
      color="currentColor"
    >
      <path
        d="M28.812 8.455h-2.353c-.014 0-.038.009-.052.009v-.01H5.621v.014c-.028-.004-.061-.013-.07-.013H3.192A3.196 3.196 0 0 0 0 11.65v8.696a3.203 3.203 0 0 0 3.193 3.198H5.55c.01 0 .043-.01.07-.015v.015h20.787v-.015a.163.163 0 0 0 .052.015h2.353A3.195 3.195 0 0 0 32 20.346V11.65a3.187 3.187 0 0 0-3.188-3.196zm-.183 1.973a1.014 1.014 0 1 1-1.012 1.012 1.006 1.006 0 0 1 1.012-1.012zm.994 4.276a1.003 1.003 0 1 1-2.005-.021 1.003 1.003 0 0 1 2.005.021zM3.521 10.428a1.89 1.89 0 1 1-.703 3.639 1.892 1.892 0 0 1-1.168-1.755c0-1.035.835-1.877 1.87-1.884zm1.007 6.22a1.001 1.001 0 0 1-1.509.882 1.007 1.007 0 0 1-.497-.882 1.024 1.024 0 0 1 .999-1.026 1.03 1.03 0 0 1 1.007 1.026zM.896 18.29a1.003 1.003 0 1 1 2.006.018 1.003 1.003 0 0 1-2.006-.018zm2.625 2.636a1.012 1.012 0 0 1-.725-1.727 1.013 1.013 0 0 1 1.732.713 1.008 1.008 0 0 1-1.007 1.014zm1.636-1.623a1.02 1.02 0 1 1-.004-2.04 1.02 1.02 0 0 1 .004 2.04zm20.092 1.42H6.774v-9.45H25.25v9.45zm.722-7.66a1.021 1.021 0 1 1 2.043.009 1.021 1.021 0 0 1-2.043-.009zm2.658 7.863a1.892 1.892 0 1 1 1.866-1.88 1.88 1.88 0 0 1-1.866 1.88zm1.622-6.836a1.019 1.019 0 0 1-.748-1.726 1.018 1.018 0 1 1 .748 1.726z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  tvIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="TvModeIcon"
      size="48"
      color="currentColor"
    >
      <g fill="currentColor">
        <path d="M11.903 16.114l-1.154-3.56H9.591l1.641 4.627h1.357l1.632-4.627h-1.163zm-7.604-2.58h1.36v3.646h1.058v-3.646h1.371v-.981H4.299zm17.743 9.126v.758H32v-6.702h-9.958z"></path>
        <path d="M8.433 21.6H4.784v1.808h3.649v.01h1.656v-.01h3.645V21.6H10.09v-.737h8.443V8.582H0v12.281h8.433v.737zM2.11 18.956v-8.453h14.31v8.453H2.11z"></path>
        <path d="M16.333 21.6h-.603v1.801h5.589v-.602h-4.986z"></path>
      </g>
    </svg>
  ),
  tabletTopIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      role="presentation"
      alt=""
      data-testid="TabletopModeIcon"
      size="48"
      color="currentColor"
    >
      <path
        d="M31.32 18.242l-2.657-6.94-1.285 6.94h3.943zM28.174 5.336H6.418l-2.74 12.906h21.754l2.741-12.906zm-5.035 10.505H6.99l1.722-8.094h16.143l-1.717 8.094zm-21.741 5.03H0v.995h.02a.098.098 0 0 0-.02.059v2.008a2.734 2.734 0 0 0 2.736 2.731h7.426a2.737 2.737 0 0 0 2.741-2.731v-2.008a.18.18 0 0 0-.01-.06h.01v-.994H1.397zm7.64.31a1 1 0 1 1-1.004 1.002c0-.554.45-1.002 1.004-1.001zm-5.845 4.43a1.837 1.837 0 1 1 1.858-1.833c-.003.49-.2.958-.55 1.302a1.839 1.839 0 0 1-1.308.53zm3.24-1.833a1.009 1.009 0 0 1 1.004-.985.981.981 0 1 1-1.004.985zm2.605 2.57a.983.983 0 1 1 .99-.978.988.988 0 0 1-.99.977zm1.591-1.591a.982.982 0 1 1 0-1.964.982.982 0 1 1 0 1.964zM32 20.87H19.097v.995h.02a.098.098 0 0 0-.02.059v2.008a2.73 2.73 0 0 0 2.731 2.731h7.431A2.738 2.738 0 0 0 32 23.933v-2.009a.18.18 0 0 0-.01-.06H32v-.994zm-3.866.31a1 1 0 0 1-.006 1.999.999.999 0 1 1 .006-1.998zm-5.85 4.43a1.836 1.836 0 0 1 0-3.673 1.837 1.837 0 1 1 0 3.672zm3.24-1.833c.015-.545.459-.98 1.004-.985a.981.981 0 1 1 0 1.964c-.544 0-.99-.434-1.004-.979zm2.61 2.57a.983.983 0 1 1 .99-.978.988.988 0 0 1-.99.977zm1.586-1.591a.982.982 0 1 1 0-1.964.982.982 0 1 1 0 1.964z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  plusIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="16"
      role="presentation"
      alt=""
      data-testid="PlusIcon"
      color="currentColor"
      size="16"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M32.04 12h-12V0h-8v12h-12v8h12v12h8V20h12v-8z"
      ></path>
    </svg>
  ),
  downloadIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="DownloadIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M4.3 19.4v5.3c0 .5.5.9 1 .9h21.4c.5 0 1-.5 1-.9v-5.3H32v6.3c-.2 2.2-2.1 4-4.4 4H4.2c-2.3 0-4.2-1.8-4.2-4v-6.3h4.3zM17.9 2.2v12.2l5-4.8 2.8 2.8-9.8 9.9L6 12.5l2.6-2.8 5.2 4.8V2.2h4.1z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  arrowNextBreadCrums: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="Breadcrumbsstyles__StyledChevronRightIcon-sc-x62fo6-3 jomfas"
      width="10"
      role="presentation"
      alt=""
      data-testid="ChevronRightIcon"
      size="10"
      color="#dadada"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#dadada"
        d="M5.3 4.3L9.8 0l16.9 16L9.8 32l-4.5-4.3L17.7 16z"
      ></path>
    </svg>
  ),
  pointTransportIcon: (
    <svg
      data-name="My Nintendo points"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="StoreNotificationstyles__MNPIcon-sc-1g8xmtg-4 jFJBrq"
      width="24"
      role="presentation"
      alt=""
      data-testid="MyNintendoPointsIcon"
      color="currentColor"
      size="24"
    >
      <path
        fill="currentColor"
        d="M31.7 13.474a11.843 11.843 0 0 0-.734-2.336 12.781 12.781 0 0 0-1.135-2.102 13.331 13.331 0 0 0-1.501-1.835 11.276 11.276 0 0 0-1.836-1.502 12.78 12.78 0 0 0-2.102-1.134 13.589 13.589 0 0 0-2.336-.734 12.638 12.638 0 0 0-5.005 0 1 1 0 0 0-.334.133A12.652 12.652 0 0 0 0 15.977 12.703 12.703 0 0 0 12.68 28.69a12.851 12.851 0 0 0 4.07-.668 1 1 0 0 0 .334.134 12.493 12.493 0 0 0 2.503.267 12.758 12.758 0 0 0 2.503-.267 11.843 11.843 0 0 0 2.335-.734 12.78 12.78 0 0 0 2.103-1.135 13.332 13.332 0 0 0 1.835-1.501 11.275 11.275 0 0 0 1.501-1.836A12.78 12.78 0 0 0 31 20.849a13.589 13.589 0 0 0 .734-2.335A12.493 12.493 0 0 0 32 16.01a15.954 15.954 0 0 0-.3-2.536zM12.68 26.287a10.088 10.088 0 0 1-7.274-3.036 10.27 10.27 0 0 1-3.003-7.308A10.088 10.088 0 0 1 5.438 8.67 10.323 10.323 0 0 1 20.02 23.285a10.405 10.405 0 0 1-7.341 3.003zm16.717-8.275a12.07 12.07 0 0 1-.567 1.869 10.503 10.503 0 0 1-.934 1.701 8.722 8.722 0 0 1-1.235 1.469 12.52 12.52 0 0 1-1.468 1.234 10.504 10.504 0 0 1-1.702.935 7.539 7.539 0 0 1-1.869.567c-.333.067-.7.133-1.034.167.4-.3.768-.634 1.135-.968A12.8 12.8 0 0 0 21.689 7a10.593 10.593 0 0 0-1.134-1 9.569 9.569 0 0 1 1.034.166 12.07 12.07 0 0 1 1.869.568 10.503 10.503 0 0 1 1.702.934 8.723 8.723 0 0 1 1.468 1.235 12.52 12.52 0 0 1 1.234 1.468 10.504 10.504 0 0 1 .935 1.702 7.539 7.539 0 0 1 .567 1.868 10.27 10.27 0 0 1 .2 2.036 8.392 8.392 0 0 1-.167 2.035z"
      ></path>
      <path
        fill="currentColor"
        d="M15.082 14.141a6.515 6.515 0 0 0-.767-.066c-.067-.2-.2-.434-.3-.701-.468-1.035-.768-1.502-1.335-1.502s-.868.467-1.335 1.502c-.1.233-.233.5-.3.7-.2.034-.467.034-.734.067-1.135.134-1.669.267-1.836.768a.735.735 0 0 0-.033.267c0 .4.234.734 1.068 1.468a6.793 6.793 0 0 0 .567.5c-.067.2-.1.468-.167.735a7.634 7.634 0 0 0-.167 1.2.949.949 0 0 0 .334.802.797.797 0 0 0 .467.166 3.271 3.271 0 0 0 1.502-.6c.233-.134.467-.267.667-.4.2.1.4.266.668.4.967.567 1.501.734 1.935.467a.922.922 0 0 0 .4-.834 8.175 8.175 0 0 0-.166-1.201c-.067-.267-.134-.534-.167-.768a6.795 6.795 0 0 0 .567-.5c.8-.735 1.068-1.068 1.068-1.469a.735.735 0 0 0-.034-.267c-.233-.433-.767-.6-1.902-.734z"
      ></path>
      <path
        fill="currentColor"
        d="M12.713 8.035a7.928 7.928 0 0 0-5.606 13.547 1.18 1.18 0 1 0 1.669-1.668 5.612 5.612 0 0 1-1.635-3.937 5.473 5.473 0 0 1 1.635-3.938 5.553 5.553 0 0 1 3.937-1.635 5.473 5.473 0 0 1 3.938 1.635 1.18 1.18 0 1 0 1.668-1.668 7.906 7.906 0 0 0-5.606-2.336z"
      ></path>
    </svg>
  ),
  transportIcon: (
    <svg
      data-name="Layer 2 copy"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="StoreNotificationstyles__ShippingIcon-sc-1g8xmtg-3 AyYis"
      width="24"
      role="presentation"
      alt=""
      data-testid="ShippingTruckArrowIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M6.57 27.352a3.373 3.373 0 1 1 3.372-3.372 3.376 3.376 0 0 1-3.373 3.372zm17.288 0a3.373 3.373 0 1 1 3.372-3.372 3.376 3.376 0 0 1-3.372 3.372z"
        fill="currentColor"
      ></path>
      <path
        d="M31.519 14.29l-3.889-3.888a1.643 1.643 0 0 0-1.161-.481h-4.4V4.648H3.436A3.327 3.327 0 0 0 0 7.831V23.98h2.196a4.373 4.373 0 0 1 8.746 0h8.535a4.373 4.373 0 0 1 8.746 0h2.134A1.643 1.643 0 0 0 32 22.336v-6.884a1.643 1.643 0 0 0-.481-1.162zM15.87 12.94l-3.946 3.946a.44.44 0 0 1-.311.13.445.445 0 0 1-.169-.034.44.44 0 0 1-.271-.407v-1.918H7.412a.44.44 0 0 1-.44-.44V11.04a.44.44 0 0 1 .44-.44h3.762V8.683a.44.44 0 0 1 .751-.311l3.946 3.946a.44.44 0 0 1 0 .622zm12.422 2.26a.66.66 0 0 1-.66.66h-4.718a.66.66 0 0 1-.66-.66v-2.834a.66.66 0 0 1 .66-.66h3.156a.66.66 0 0 1 .467.193l1.561 1.562a.66.66 0 0 1 .194.466z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  headerTabletListIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="HamburgerMenuIcon"
      color="currentColor"
      size="24"
    >
      <path
        fill="currentColor"
        d="M0 12.8h32v6.4H0zM0 24h32v6.4H0zM0 1.6h32V8H0z"
      ></path>
    </svg>
  ),
  headerTabletHeartIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="HeartIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M22.3 1.3c-2.3 0-4.5 1-6.3 2.8-1.7-1.8-3.9-2.8-6.3-2.8C4.4 1.3 0 5.7 0 11.2c0 2.6 1.2 5.1 3.3 7.3L15 30.2c.3.3.6.4 1 .4.3 0 .7-.1 1-.4l11.6-11.6c1.5-1.8 3.3-4.3 3.3-7.5.1-5.4-4.3-9.8-9.6-9.8z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  headerTabletSearchIcon: (
    <svg
      data-name="Magnifying glass"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="32"
      role="presentation"
      alt=""
      data-testid="MagnifyingGlassIcon"
      size="32"
      color="currentColor"
    >
      <path
        d="M31.564 28.745l-8.73-8.73a12.66 12.66 0 1 0-2.804 2.834l8.715 8.715a1.5 1.5 0 0 0 2.114 0l.705-.705a1.5 1.5 0 0 0 0-2.114zm-18.966-7.433A8.611 8.611 0 1 1 21.21 12.7a8.62 8.62 0 0 1-8.612 8.612z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  headerTabletCartIcon: (
    <svg
      data-name="Shopping cart"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="ShoppingCartIcon"
      size="24"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M23.12 28.073a2.248 2.248 0 1 0 2.25-2.326h-.005a2.288 2.288 0 0 0-2.245 2.326zm2.397-7.29a1.728 1.728 0 0 0 1.498-.982l4.844-11.686a1.544 1.544 0 0 0-.15-1.551 1.593 1.593 0 0 0-1.349-.673H8.44l-.55-2.895A1.494 1.494 0 0 0 6.393 1.6H1.598A1.606 1.606 0 0 0 0 3.255a1.548 1.548 0 0 0 1.598 1.654h3.496L7.49 18.973l-1.098 4.706a1.67 1.67 0 0 0 .25 1.395 1.529 1.529 0 0 0 1.198.673h18.675a1.656 1.656 0 0 0 0-3.31H9.937l.4-1.654zm-18.726 7.29a2.248 2.248 0 1 0 2.25-2.326h-.005a2.288 2.288 0 0 0-2.245 2.326z"
      ></path>
    </svg>
  ),
  headerTabletUserIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="UserIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M16.22 19.41A9.71 9.71 0 1 1 26 9.7a9.74 9.74 0 0 1-9.8 9.71M1.84 32a10.88 10.88 0 0 1 10.94-10.74h6.57A10.88 10.88 0 0 1 30.29 32H1.84"
        fill="currentColor"
      ></path>
    </svg>
  ),
  headerCloseIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      role="presentation"
      alt=""
      data-testid="CloseCircleIcon"
      size="26"
      color="currentColor"
    >
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm5.735 8L16 13.735 10.265 8 8 10.265 13.735 16 8 21.735 10.265 24 16 18.265 21.735 24 24 21.735 18.265 16 24 10.265 21.735 8z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  headerArrowNextIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="14"
      role="presentation"
      alt=""
      data-testid="ChevronRightIcon"
      size="14"
      color="currentColor"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
        d="M5.3 4.3L9.8 0l16.9 16L9.8 32l-4.5-4.3L17.7 16z"
      ></path>
    </svg>
  ),
  headerArrowDownIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="14"
      role="presentation"
      alt=""
      data-testid="ChevronDownIcon"
      size="14"
      color="currentColor"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
        d="M27.7 5.3L32 9.8 16 26.7 0 9.8l4.3-4.5L16 17.7z"
      ></path>
    </svg>
  ),
  headerArrowUpIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="14"
      role="presentation"
      alt=""
      data-testid="ChevronDownIcon"
      size="14"
      color="currentColor"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
        d="M27.7 5.3L32 9.8 16 26.7 0 9.8l4.3-4.5L16 17.7z"
      ></path>
    </svg>
  ),
  headerArrowPrevIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="14"
      role="presentation"
      alt=""
      data-testid="ChevronLeftIcon"
      size="14"
      color="currentColor"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
        d="M14.3 16l12.4 11.7-4.5 4.3L5.3 16 22.2 0l4.5 4.3z"
      ></path>
    </svg>
  ),
  mark: (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="11"
      role="presentation"
      alt=""
      data-testid="CheckmarkIcon"
      size="11"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M26.737 2L12.786 21.945 4.047 15.82.5 20.394 14.204 30 31.5 5.274 26.737 2z"
      ></path>
    </svg>
  ),
  skeletonIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="ReceiptIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M26 1.6L24 0l-2 1.6L20 0l-2 1.6L16 0l-2 1.6L12 0l-2 1.6L8 0 6 1.6 4 0v30.4L6 32l2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6 2 1.6 2-1.6V0l-2 1.6zM8 6h8v2H8V6zm16 20H8v-2h16v2zm0-4H8v-2h16v2zm0-4H8v-2h16v2zm0-4H8v-2h16v2z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  offSiteIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="14"
      role="presentation"
      alt=""
      data-testid="OffsiteIcon"
      size="14"
      color="currentColor"
    >
      <path
        d="M12.7 5.3v4H4V28h17.3v-8.7h4v10c0 1.5-1.2 2.7-2.7 2.7h-20C1.2 32 0 30.8 0 29.3V8c0-1.5 1.2-2.7 2.7-2.7h10zM32 0v16h-4V6.8L15.1 19.9 12.2 17l13-13H16V0h16z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  cardCodeIcon: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="GiftIcon"
      size="18"
      color="currentColor"
    >
      <g fill="currentColor">
        <path d="M12.151 13.21c.204 0 .406-.035.599-.1.73-.171 1.2-.882 1.073-1.621a1.25 1.25 0 0 0-1.236-.739c-.203 0-.406.035-.598.1a1.417 1.417 0 0 0-1.073 1.621c.214.483.709.779 1.235.739zm-4.561 0a1.247 1.247 0 0 0 1.235-.739 1.414 1.414 0 0 0-1.073-1.62 1.84 1.84 0 0 0-.598-.1 1.247 1.247 0 0 0-1.235.738 1.415 1.415 0 0 0 1.073 1.62c.192.066.394.1.598.1z"></path>
        <path d="M0 8.533v4.8h4.897c-.5-.664-.65-1.53-.4-2.324A2.724 2.724 0 0 1 7.154 9.25 3.257 3.257 0 0 1 9 9.817V5.333H3.2a3.197 3.197 0 0 0-3.2 3.2zm28.8-3.2H11v4.318a3.336 3.336 0 0 1 1.587-.401 2.724 2.724 0 0 1 2.657 1.76c.25.793.1 1.659-.4 2.323H32v-4.8a3.2 3.2 0 0 0-3.2-3.2zM14.52 16.908a.75.75 0 1 1-.91 1.192L11 16.106v10.56h17.8a3.196 3.196 0 0 0 3.2-3.199v-8.134H12.46l2.06 1.575zm-8.843 1.346a.749.749 0 0 1-.456-1.346l2.061-1.575H0v8.134a3.2 3.2 0 0 0 3.2 3.2H9V15.908L6.131 18.1c-.13.1-.29.154-.454.154z"></path>
      </g>
    </svg>
  ),
  settingIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="GearIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M30.6 13.1h-2.4c-.3-1.4-.8-2.6-1.5-3.8l1.7-1.7c.5-.5.5-1.4 0-1.9l-2.1-2.1c-.5-.5-1.4-.5-1.9 0l-1.7 1.7c-1.2-.7-2.4-1.3-3.8-1.5V1.4c0-.7-.6-1.4-1.4-1.4h-3c-.7 0-1.4.6-1.4 1.4v2.4c-1.4.4-2.6.8-3.8 1.5L7.6 3.6c-.5-.5-1.4-.5-1.9 0L3.6 5.7c-.6.5-.6 1.4 0 1.9l1.7 1.7c-.7 1.2-1.3 2.4-1.5 3.8H1.3c-.7 0-1.4.6-1.4 1.4v3c0 .7.6 1.4 1.4 1.4h2.4c.3 1.4.8 2.6 1.5 3.8l-1.7 1.7c-.5.5-.5 1.4 0 1.9l2.1 2.1c.6.5 1.4.5 2 0l1.7-1.7c1.2.7 2.4 1.3 3.8 1.5v2.5c0 .7.6 1.4 1.4 1.4h3c.7 0 1.4-.6 1.4-1.4v-2.4c1.4-.3 2.6-.8 3.8-1.5l1.7 1.7c.5.5 1.4.5 1.9 0l2.1-2.1c.5-.5.5-1.4 0-1.9l-1.7-1.7c.7-1.2 1.3-2.4 1.5-3.8h2.4c.7 0 1.4-.6 1.4-1.4v-3c.1-.9-.6-1.5-1.4-1.5zM16 21.6c-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6 3.1 0 5.6 2.5 5.6 5.6-.1 3.1-2.6 5.6-5.6 5.6z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  region: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="24"
      role="presentation"
      alt=""
      data-testid="FlagUsaIcon"
      color="currentColor"
      size="24"
    >
      <path
        d="M29.7 5.7H2.3C1 5.7 0 6.7 0 8v16c0 1.3 1 2.3 2.3 2.3h27.4c1.3 0 2.3-1 2.3-2.3V8c0-1.3-1-2.3-2.3-2.3z"
        fill="#fff"
      ></path>
      <path
        fill="#bf0a30"
        d="M0 10.3h32v2.3H0zM32 8H0c0-1.3 1-2.3 2.3-2.3h27.4C31 5.7 32 6.7 32 8zM32 24H0c0 1.3 1 2.3 2.3 2.3h27.4c1.3 0 2.3-1 2.3-2.3zM0 14.9h32v2.3H0zM0 19.4h32v2.3H0z"
      ></path>
      <path d="M16 17.1H0V8c0-1.3 1-2.3 2.3-2.3H16v11.4z" fill="#002868"></path>
    </svg>
  ),
  support: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="SupportIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M28.126.862H3.876A3.904 3.904 0 0 0 0 4.757v17.838a3.905 3.905 0 0 0 3.875 3.896h8.375c.125 0 .125 0 .125.125l3.626 4.397a.122.122 0 0 0 .125.125c.125 0 .125 0 .25-.125L20 26.616a.122.122 0 0 1 .124-.125h8.001A3.904 3.904 0 0 0 32 22.595V4.757A3.903 3.903 0 0 0 28.126.862zM17.954 20.91a2.018 2.018 0 0 1-.438.64 2.062 2.062 0 0 1-1.446.58 2.092 2.092 0 0 1-.802-.154 1.944 1.944 0 0 1-.652-.43 1.98 1.98 0 0 1-.427-.642 2.119 2.119 0 0 1-.001-1.59 1.97 1.97 0 0 1 .43-.65 2.055 2.055 0 0 1 .643-.432 2.078 2.078 0 0 1 1.613 0 2.152 2.152 0 0 1 .64.428l.002.001a2.045 2.045 0 0 1 .438 2.25zm2.964-10.055a4.505 4.505 0 0 1-.662 1.159 5.04 5.04 0 0 1-.861.844l-.822.622a6.01 6.01 0 0 0-.626.538.766.766 0 0 0-.231.426l-.303 1.923h-2.517l-.222-2.13a1.824 1.824 0 0 1 .193-1.127 3.152 3.152 0 0 1 .648-.812 7.965 7.965 0 0 1 .838-.658 6.94 6.94 0 0 0 .782-.626 3.116 3.116 0 0 0 .574-.716 1.726 1.726 0 0 0 .208-.873 1.287 1.287 0 0 0-.112-.55 1.213 1.213 0 0 0-.318-.414 1.482 1.482 0 0 0-.506-.275 2.946 2.946 0 0 0-1.628.018 3.595 3.595 0 0 0-.666.277 8.824 8.824 0 0 0-.49.294.966.966 0 0 1-1.483-.33l-.872-1.378.24-.212a8 8 0 0 1 .86-.657 6.234 6.234 0 0 1 1.023-.55 6.4 6.4 0 0 1 1.192-.37 6.63 6.63 0 0 1 3.248.15 4.301 4.301 0 0 1 1.475.826 3.736 3.736 0 0 1 .966 1.314 4.161 4.161 0 0 1 .34 1.703 4.304 4.304 0 0 1-.268 1.584z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  logo: (
    <svg
      viewBox="0 0 97 24"
      xmlns="http://www.w3.org/2000/svg"
      width="89"
      role="presentation"
      alt=""
      data-testid="NintendoRacetrackLogoIcon"
      size="89"
      color="currentColor"
    >
      <path
        d="M17.945 14.157l-4.85-7.838H9.609V17.59h3.486V9.752l4.85 7.838h3.456V6.32h-3.486l.03 7.837zm27.554-4.04V8.993H43.68v-1.52h-3.395v1.52h-1.849v1.124h1.85v7.473h3.394v-7.473h1.82zM23.341 17.56h3.364v-7.474h-3.364v7.474zm0-8.932h3.395V6.319H23.34v2.309zm59.17.942c-2.728 0-4.941 1.883-4.941 4.192s2.213 4.193 4.94 4.193c2.729 0 4.942-1.884 4.942-4.193 0-2.309-2.213-4.192-4.941-4.192zm1.364 5.772c0 1.185-.698 1.67-1.364 1.67-.667 0-1.395-.485-1.395-1.67v-3.16c0-1.184.697-1.67 1.395-1.67.666 0 1.364.486 1.364 1.67v3.16zm-10.73-4.891c-.547-.304-1.123-.608-1.91-.669-2.426-.212-4.305 1.945-4.305 3.92 0 2.612 2 3.554 2.304 3.706 1.152.516 2.607.547 3.88-.274v.426h3.334V6.32h-3.334c.03 0 .03 2.4.03 4.13zm.03 3.342v1.336c0 1.155-.789 1.458-1.334 1.458-.546 0-1.334-.303-1.334-1.458v-2.673c0-1.155.788-1.458 1.334-1.458.515 0 1.333.303 1.333 1.458v1.337zM34.616 9.752c-1.122.03-2.031.516-2.698 1.124v-.79h-3.365v7.474h3.365v-4.922c0-.638.697-1.367 1.607-1.367.909 0 1.546.73 1.546 1.367v4.922h3.364v-4.071c0-2.947-2.546-3.798-3.82-3.737zm27.433 0a4.075 4.075 0 0 0-2.698 1.124v-.79h-3.365v7.474h3.365v-4.922c0-.638.697-1.367 1.606-1.367.91 0 1.546.73 1.546 1.367v4.922h3.365v-4.071c0-2.947-2.546-3.798-3.82-3.737zm-7.063 4.101c0-2.309-2.243-4.253-4.971-4.253-2.759 0-4.972 1.884-4.972 4.193 0 2.308 2.213 4.192 4.972 4.192 2.273 0 4.213-1.306 4.789-3.068H51.44v.455c0 1.367-.91 1.671-1.394 1.671-.515 0-1.425-.304-1.425-1.67v-1.55l6.366.03zm-6.123-2.643a1.391 1.391 0 0 1 1.182-.668c.455 0 .91.213 1.182.668.212.365.212.82.212 1.458H48.62c0-.637.03-1.063.243-1.458zm39.921-3.493c0-.365-.272-.547-.818-.547h-.758v1.914h.455v-.79h.242l.364.79h.515l-.424-.851c.273-.091.424-.273.424-.516zm-.879.273h-.242v-.547h.212c.273 0 .424.091.424.274 0 .212-.12.273-.394.273zm.03-1.58c-.94 0-1.727.79-1.727 1.732s.788 1.732 1.728 1.732 1.727-.79 1.727-1.732a1.73 1.73 0 0 0-1.727-1.732zm0 3.13a1.413 1.413 0 0 1-1.394-1.398c0-.76.637-1.398 1.395-1.398.757 0 1.394.638 1.394 1.398 0 .76-.637 1.397-1.394 1.397zM84.148 0H12.64C5.062-.03 0 5.438 0 11.97c0 6.53 5.062 11.939 12.67 11.939h71.508c7.608 0 12.67-5.408 12.67-11.94C96.818 5.44 91.726 0 84.148 0zm-.03 20.993H12.671c-6.033.03-9.7-4.041-9.7-9.023 0-4.983 3.698-8.993 9.7-9.023h71.446c6.002 0 9.7 4.04 9.7 9.023 0 4.982-3.668 9.023-9.7 9.023z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  logoLarge: (
    <svg
      viewBox="0 0 97 24"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      role="presentation"
      alt=""
      data-testid="NintendoRacetrackLogoIcon"
      size="89"
      color="currentColor"
    >
      <path
        d="M17.945 14.157l-4.85-7.838H9.609V17.59h3.486V9.752l4.85 7.838h3.456V6.32h-3.486l.03 7.837zm27.554-4.04V8.993H43.68v-1.52h-3.395v1.52h-1.849v1.124h1.85v7.473h3.394v-7.473h1.82zM23.341 17.56h3.364v-7.474h-3.364v7.474zm0-8.932h3.395V6.319H23.34v2.309zm59.17.942c-2.728 0-4.941 1.883-4.941 4.192s2.213 4.193 4.94 4.193c2.729 0 4.942-1.884 4.942-4.193 0-2.309-2.213-4.192-4.941-4.192zm1.364 5.772c0 1.185-.698 1.67-1.364 1.67-.667 0-1.395-.485-1.395-1.67v-3.16c0-1.184.697-1.67 1.395-1.67.666 0 1.364.486 1.364 1.67v3.16zm-10.73-4.891c-.547-.304-1.123-.608-1.91-.669-2.426-.212-4.305 1.945-4.305 3.92 0 2.612 2 3.554 2.304 3.706 1.152.516 2.607.547 3.88-.274v.426h3.334V6.32h-3.334c.03 0 .03 2.4.03 4.13zm.03 3.342v1.336c0 1.155-.789 1.458-1.334 1.458-.546 0-1.334-.303-1.334-1.458v-2.673c0-1.155.788-1.458 1.334-1.458.515 0 1.333.303 1.333 1.458v1.337zM34.616 9.752c-1.122.03-2.031.516-2.698 1.124v-.79h-3.365v7.474h3.365v-4.922c0-.638.697-1.367 1.607-1.367.909 0 1.546.73 1.546 1.367v4.922h3.364v-4.071c0-2.947-2.546-3.798-3.82-3.737zm27.433 0a4.075 4.075 0 0 0-2.698 1.124v-.79h-3.365v7.474h3.365v-4.922c0-.638.697-1.367 1.606-1.367.91 0 1.546.73 1.546 1.367v4.922h3.365v-4.071c0-2.947-2.546-3.798-3.82-3.737zm-7.063 4.101c0-2.309-2.243-4.253-4.971-4.253-2.759 0-4.972 1.884-4.972 4.193 0 2.308 2.213 4.192 4.972 4.192 2.273 0 4.213-1.306 4.789-3.068H51.44v.455c0 1.367-.91 1.671-1.394 1.671-.515 0-1.425-.304-1.425-1.67v-1.55l6.366.03zm-6.123-2.643a1.391 1.391 0 0 1 1.182-.668c.455 0 .91.213 1.182.668.212.365.212.82.212 1.458H48.62c0-.637.03-1.063.243-1.458zm39.921-3.493c0-.365-.272-.547-.818-.547h-.758v1.914h.455v-.79h.242l.364.79h.515l-.424-.851c.273-.091.424-.273.424-.516zm-.879.273h-.242v-.547h.212c.273 0 .424.091.424.274 0 .212-.12.273-.394.273zm.03-1.58c-.94 0-1.727.79-1.727 1.732s.788 1.732 1.728 1.732 1.727-.79 1.727-1.732a1.73 1.73 0 0 0-1.727-1.732zm0 3.13a1.413 1.413 0 0 1-1.394-1.398c0-.76.637-1.398 1.395-1.398.757 0 1.394.638 1.394 1.398 0 .76-.637 1.397-1.394 1.397zM84.148 0H12.64C5.062-.03 0 5.438 0 11.97c0 6.53 5.062 11.939 12.67 11.939h71.508c7.608 0 12.67-5.408 12.67-11.94C96.818 5.44 91.726 0 84.148 0zm-.03 20.993H12.671c-6.033.03-9.7-4.041-9.7-9.023 0-4.983 3.698-8.993 9.7-9.023h71.446c6.002 0 9.7 4.04 9.7 9.023 0 4.982-3.668 9.023-9.7 9.023z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  store: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="MyNintendoTileIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M26.667 0H5.333A5.333 5.333 0 0 0 0 5.333v21.334A5.333 5.333 0 0 0 5.333 32h21.334A5.333 5.333 0 0 0 32 26.667V5.333A5.333 5.333 0 0 0 26.667 0zm-5.105 22.423a5.212 5.212 0 0 1-2.37-.602 10.482 10.482 0 0 1-13.67-1.608.803.803 0 0 1 1.228-1.036 8.866 8.866 0 0 0 11.914 1.04.803.803 0 0 1 .986-.005 3.461 3.461 0 0 0 5.41-2.888 3.495 3.495 0 0 0-3.39-3.416c-.016 0-.036 0-.063-.002a.962.962 0 0 0-.12.003.806.806 0 0 1-.778-.455 6.54 6.54 0 0 0-5.992-3.848c-2.82 0-5.738 1.802-5.738 4.819-.003.818.35 1.596.969 2.132l1.688-3.147a.803.803 0 0 1 1.423.015l.982 1.926.983-1.926a.8.8 0 0 1 .71-.438c.3 0 .574.164.716.428l2.076 3.933a.8.8 0 0 1-.03.804.802.802 0 0 1-1.391-.054l-1.353-2.564-.995 1.95a.803.803 0 0 1-1.431-.001l-1-1.96-1.384 2.58a.805.805 0 0 1-1.046.349 4.563 4.563 0 0 1-2.524-4.027C7.372 10.403 11.107 8 14.717 8a8.081 8.081 0 0 1 7.209 4.308 5.063 5.063 0 0 1-.363 10.115z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  game: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="DPadIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M30.1 10.4h-8.5V1.9c0-1-.8-1.9-1.9-1.9h-7.5c-1 0-1.9.8-1.9 1.9v8.5H1.9c-1 0-1.9.8-1.9 1.9v7.5c0 1 .8 1.9 1.9 1.9h8.5v8.5c0 1 .8 1.9 1.9 1.9h7.5c1 0 1.9-.8 1.9-1.9v-8.5h8.5c1 0 1.9-.8 1.9-1.9v-7.5c-.1-1.1-.9-1.9-2-1.9zM7.5 16.9H3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9s-.5.9-1 .9zm9.4 11.3c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.8zm0-20.7c0 .5-.4.9-.9.9s-.9-.4-.9-.9V3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.7zm11.3 9.4h-3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9.1.5-.3.9-.9.9z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  gameFullWidth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      role="presentation"
      alt=""
      data-testid="DPadIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M30.1 10.4h-8.5V1.9c0-1-.8-1.9-1.9-1.9h-7.5c-1 0-1.9.8-1.9 1.9v8.5H1.9c-1 0-1.9.8-1.9 1.9v7.5c0 1 .8 1.9 1.9 1.9h8.5v8.5c0 1 .8 1.9 1.9 1.9h7.5c1 0 1.9-.8 1.9-1.9v-8.5h8.5c1 0 1.9-.8 1.9-1.9v-7.5c-.1-1.1-.9-1.9-2-1.9zM7.5 16.9H3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9s-.5.9-1 .9zm9.4 11.3c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.8zm0-20.7c0 .5-.4.9-.9.9s-.9-.4-.9-.9V3.8c0-.5.4-.9.9-.9s.9.4.9.9v3.7zm11.3 9.4h-3.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.8c.5 0 .9.4.9.9.1.5-.3.9-.9.9z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  switchIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="SwitchIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M13.54 0a.18.18 0 0 1 .17.17v31.66a.15.15 0 0 1-.17.17H8.11a6.86 6.86 0 0 1-6.85-6.8V6.74A6.81 6.81 0 0 1 8.11 0h5.43zm10.4 0a6.77 6.77 0 0 1 6.8 6.74V25.2a6.82 6.82 0 0 1-6.85 6.8h-5.43a.15.15 0 0 1-.17-.17V.17c0-.11.11-.17.22-.17h5.43zM7.49 19.6a1.26 1.26 0 1 0 0 2.51 1.32 1.32 0 0 0 1.31-1.25 1.28 1.28 0 0 0-1.31-1.26zm17-3.6a2.86 2.86 0 0 0-2.85 2.86A2.86 2.86 0 1 0 24.51 16zm-14.28.86a1.26 1.26 0 1 0 0 2.51 1.35 1.35 0 0 0 1.31-1.26 1.32 1.32 0 0 0-1.29-1.25zm-5.49 0a1.26 1.26 0 1 0 0 2.51 1.36 1.36 0 0 0 1.32-1.26 1.28 1.28 0 0 0-1.3-1.25zm2.75-2.69a1.26 1.26 0 1 0 0 2.52 1.37 1.37 0 0 0 1.33-1.26 1.28 1.28 0 0 0-1.31-1.26zm17-4a1.36 1.36 0 0 0-1.31 1.26 1.32 1.32 0 1 0 1.31-1.26zm-17-5.08a2.86 2.86 0 1 0 0 5.71 2.86 2.86 0 0 0 2.85-2.86 2.82 2.82 0 0 0-2.83-2.85zm19.77 2.4a1.26 1.26 0 1 0 1.31 1.25 1.32 1.32 0 0 0-1.29-1.25zm-5.43 0a1.26 1.26 0 1 0 1.31 1.25 1.29 1.29 0 0 0-1.29-1.25zm2.68-2.75A1.36 1.36 0 0 0 23.2 6a1.32 1.32 0 1 0 1.31-1.26z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  switchIconLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="42"
      role="presentation"
      alt=""
      data-testid="SwitchIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M13.54 0a.18.18 0 0 1 .17.17v31.66a.15.15 0 0 1-.17.17H8.11a6.86 6.86 0 0 1-6.85-6.8V6.74A6.81 6.81 0 0 1 8.11 0h5.43zm10.4 0a6.77 6.77 0 0 1 6.8 6.74V25.2a6.82 6.82 0 0 1-6.85 6.8h-5.43a.15.15 0 0 1-.17-.17V.17c0-.11.11-.17.22-.17h5.43zM7.49 19.6a1.26 1.26 0 1 0 0 2.51 1.32 1.32 0 0 0 1.31-1.25 1.28 1.28 0 0 0-1.31-1.26zm17-3.6a2.86 2.86 0 0 0-2.85 2.86A2.86 2.86 0 1 0 24.51 16zm-14.28.86a1.26 1.26 0 1 0 0 2.51 1.35 1.35 0 0 0 1.31-1.26 1.32 1.32 0 0 0-1.29-1.25zm-5.49 0a1.26 1.26 0 1 0 0 2.51 1.36 1.36 0 0 0 1.32-1.26 1.28 1.28 0 0 0-1.3-1.25zm2.75-2.69a1.26 1.26 0 1 0 0 2.52 1.37 1.37 0 0 0 1.33-1.26 1.28 1.28 0 0 0-1.31-1.26zm17-4a1.36 1.36 0 0 0-1.31 1.26 1.32 1.32 0 1 0 1.31-1.26zm-17-5.08a2.86 2.86 0 1 0 0 5.71 2.86 2.86 0 0 0 2.85-2.86 2.82 2.82 0 0 0-2.83-2.85zm19.77 2.4a1.26 1.26 0 1 0 1.31 1.25 1.32 1.32 0 0 0-1.29-1.25zm-5.43 0a1.26 1.26 0 1 0 1.31 1.25 1.29 1.29 0 0 0-1.29-1.25zm2.68-2.75A1.36 1.36 0 0 0 23.2 6a1.32 1.32 0 1 0 1.31-1.26z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  feedback: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="NewsIcon"
      size="18"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M31.92 3.62a1.945 1.945 0 0 0-1.953-1.932H1.874A1.945 1.945 0 0 0-.08 3.62v10.068h32zm-32 11.692v7.201a2.027 2.027 0 0 0 1.954 1.998h8.711a2.777 2.777 0 0 1 2.178 1.073q2.97 4.736 3.315 4.728.344-.009 3.315-4.837a2.677 2.677 0 0 1 2.177-.964h8.398a2.027 2.027 0 0 0 1.953-1.998v-7.201zm14 5.15c0 .056-.07.1-.155.1H3.077c-.086 0-.156-.044-.156-.1v-1.051c0-.055.07-.1.156-.1h10.688c.086 0 .156.045.156.1z"
      ></path>
    </svg>
  ),
  feedbackLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="indexstyles__PageIcon-sc-vbvrao-4 gkRnLp"
      width="24"
      role="presentation"
      alt=""
      data-testid="NewsIcon"
      color="currentColor"
      size="24"
    >
      <path
        fill="currentColor"
        d="M31.92 3.62a1.945 1.945 0 0 0-1.953-1.932H1.874A1.945 1.945 0 0 0-.08 3.62v10.068h32zm-32 11.692v7.201a2.027 2.027 0 0 0 1.954 1.998h8.711a2.777 2.777 0 0 1 2.178 1.073q2.97 4.736 3.315 4.728.344-.009 3.315-4.837a2.677 2.677 0 0 1 2.177-.964h8.398a2.027 2.027 0 0 0 1.953-1.998v-7.201zm14 5.15c0 .056-.07.1-.155.1H3.077c-.086 0-.156-.044-.156-.1v-1.051c0-.055.07-.1.156-.1h10.688c.086 0 .156.045.156.1z"
      ></path>
    </svg>
  ),
  star: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="StarPlayNintendoIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M18.9 19.1c-.9 0-1-1.5-1-3.4s0-3.5 1-3.4c.9.1 1.1 1.4 1.1 3.3-.1 2-.2 3.5-1.1 3.5m-5.8 0c-.9 0-1-1.6-1-3.4 0-1.9.2-3.2 1.1-3.3 1-.1 1 1.5 1 3.4-.1 1.8-.2 3.3-1.1 3.3M32 12.4c-.1-.3-1.4-.6-5.6-1.1-2.6-.3-5.1-.5-5.2-.5-.2 0-.4-.2-.5-.4-.6-1.6-1.3-3.3-2-4.8C17.1 1.8 16.4.7 15.9.7c-.4 0-1 1.1-2.8 5-1.1 2.4-2 4.8-2 4.8-.1.2-.3.4-.5.4 0 0-2.5.1-5.1.4-4.1.4-5.4.7-5.5 1-.1.4.8 1.3 3.9 4.2 1.9 1.8 3.9 3.4 3.9 3.4.2.1.2.3.2.4v.1s-.6 2.5-1.2 5.1c-.6 3-1.1 5.4-.7 5.7.4.4 1.8-.5 5.2-2.4 2.3-1.3 4.4-2.7 4.5-2.7.2-.1.4-.1.6 0 0 0 2.2 1.4 4.4 2.7 3.4 2 4.7 2.7 5.2 2.4.4-.3 0-2.1-.7-5.7-.5-2.6-1.2-5.1-1.2-5.1v-.1c0-.2.1-.3.2-.4 0 0 1.9-1.6 3.9-3.3 3-2.9 3.9-3.9 3.8-4.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  star2: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="StarFilledIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M31.993 12.369c-.107-.34-1.43-.62-5.599-1.09-2.626-.297-5.15-.455-5.175-.456a.577.577 0 0 1-.504-.37 137.666 137.666 0 0 0-1.982-4.837C17.093 1.821 16.428.71 15.973.713c-.412-.005-1.027 1.122-2.767 4.975a112.804 112.804 0 0 0-2.014 4.781.58.58 0 0 1-.506.367c-.025.002-2.527.146-5.13.43-4.145.453-5.48.706-5.552 1.069-.073.398.774 1.333 3.88 4.163a114.143 114.143 0 0 0 3.921 3.393.58.58 0 0 1 .193.594c-.006.025-.645 2.472-1.183 5.06-.615 2.958-1.072 5.368-.709 5.66.447.364 1.796-.484 5.182-2.416A123.355 123.355 0 0 0 15.75 26.1a.58.58 0 0 1 .622 0c.022.014 2.163 1.355 4.448 2.68 3.45 1.998 4.747 2.668 5.163 2.42.422-.301.042-2.118-.706-5.708a121.87 121.87 0 0 0-1.189-5.106.58.58 0 0 1 .195-.595c.019-.015 1.946-1.588 3.873-3.333 3.055-2.765 3.932-3.734 3.837-4.09"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  star2FullWidth: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      role="presentation"
      alt=""
      data-testid="StarFilledIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M31.993 12.369c-.107-.34-1.43-.62-5.599-1.09-2.626-.297-5.15-.455-5.175-.456a.577.577 0 0 1-.504-.37 137.666 137.666 0 0 0-1.982-4.837C17.093 1.821 16.428.71 15.973.713c-.412-.005-1.027 1.122-2.767 4.975a112.804 112.804 0 0 0-2.014 4.781.58.58 0 0 1-.506.367c-.025.002-2.527.146-5.13.43-4.145.453-5.48.706-5.552 1.069-.073.398.774 1.333 3.88 4.163a114.143 114.143 0 0 0 3.921 3.393.58.58 0 0 1 .193.594c-.006.025-.645 2.472-1.183 5.06-.615 2.958-1.072 5.368-.709 5.66.447.364 1.796-.484 5.182-2.416A123.355 123.355 0 0 0 15.75 26.1a.58.58 0 0 1 .622 0c.022.014 2.163 1.355 4.448 2.68 3.45 1.998 4.747 2.668 5.163 2.42.422-.301.042-2.118-.706-5.708a121.87 121.87 0 0 0-1.189-5.106.58.58 0 0 1 .195-.595c.019-.015 1.946-1.588 3.873-3.333 3.055-2.765 3.932-3.734 3.837-4.09"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  nitendoStore: (
    <svg
      viewBox="0 0 135 18"
      xmlns="http://www.w3.org/2000/svg"
      width="188"
      role="presentation"
      alt=""
      data-testid="MyNintendoStoreLogoIcon"
      size="188"
      color="currentColor"
    >
      <path
        d="M76.974 9.947c-.19-.58-.727-1.197-1.672-1.197-.67 0-1.337.342-1.632 1.197h3.304zm1.781.54c0 .641-.42.81-1.25.81h-3.862c.187.86.965 1.313 1.632 1.313.658 0 1.155-.24 1.561-.761l1.553.564c-.505 1.03-1.674 1.854-3.098 1.854-1.956 0-3.44-1.76-3.44-3.6 0-1.78 1.45-3.578 3.422-3.578 2.27 0 3.455 1.996 3.483 3.398zm4.316-3.397c-.713 0-1.35.298-1.738.784h-.02V7.3h-1.904v6.758h1.903v-3.29c0-1.314.692-1.88 1.477-1.88.545 0 1.375.357 1.375 1.686v3.48h1.903V10.43c0-2.273-1.52-3.339-2.996-3.339zM70.409 5.435H68.51v1.863h-1.27v1.593h1.27v5.165h1.9V8.891h1.286V7.298H70.41V5.435h-.001zm29.304 5.246c0-1.001-.773-1.816-1.724-1.816-.95 0-1.723.815-1.723 1.816 0 1.002.773 1.817 1.724 1.817.95 0 1.724-.815 1.724-1.817h-.001zm1.771-.002c0 1.978-1.564 3.588-3.494 3.588-1.931 0-3.494-1.61-3.494-3.588 0-1.98 1.563-3.59 3.494-3.59 1.93 0 3.494 1.612 3.494 3.59zm1.184 3.093l-.147-.518h-.267v.805h.183l-.006-.603.169.603h.132l.168-.603-.006.603h.183v-.805h-.268l-.141.518zM91.96 10.677c0-1.022-.736-1.83-1.732-1.83-.995 0-1.755.822-1.755 1.83s.76 1.829 1.755 1.829c.996 0 1.732-.808 1.732-1.829zm-.01-6.133h1.904v9.515H91.95v-.5h-.032c-.15.231-.854.708-1.753.708-1.877 0-3.458-1.617-3.458-3.59 0-1.973 1.58-3.588 3.458-3.588.9 0 1.602.474 1.753.705h.032v-3.25zM35.933 4.48c-.484 0-1.023.197-1.45 1.202-.292.69-2.296 5.375-2.296 5.375h-.038l-2.298-5.378c-.427-1.002-.994-1.198-1.45-1.198-.661 0-1.276.451-1.276 1.53v8.046h2.042V8.753h.04l1.903 4.464c.33.773.697.902 1.057.902.361 0 .729-.129 1.058-.902l1.903-4.464h.04v5.303h2.042V6.018c0-1.079-.56-1.54-1.277-1.54zm65.714 8.955h.153v.625h.2v-.625h.153v-.18h-.506v.18zm-59.967-1.95L40.086 7.29h-2.128l2.844 6.63c-.182.876-.727 1.218-1.488 1.218h-.279v1.687h.362c1.454 0 2.207-.269 2.66-1.412.112-.28 3.2-8.123 3.2-8.123h-2.143l-1.434 4.194zM17.73 5.156C16.182 2.24 13.406.515 10.203.515c-3.769 0-7.667 2.59-7.667 6.922 0 3.042 2.526 4.287 2.635 4.338a.825.825 0 0 0 1.091-.376l1.445-2.78 1.044 2.113c.144.29.431.472.747.472s.604-.182.747-.472l1.039-2.1 1.413 2.762a.826.826 0 0 0 1.132.362.88.88 0 0 0 .35-1.17l-2.166-4.237a.846.846 0 0 0-.749-.461.835.835 0 0 0-.74.472L9.498 8.435 8.473 6.36a.835.835 0 0 0-.739-.472.837.837 0 0 0-.748.456l-1.762 3.39C4.757 9.3 4.213 8.557 4.213 7.437c0-3.249 3.045-5.191 5.99-5.191 2.715 0 5.054 1.55 6.256 4.145.148.32.47.513.813.49.08-.005.11-.003.125-.003.028.002.049.002.066.002 2.086 0 3.54 1.94 3.54 3.68 0 2.11-1.605 3.763-3.652 3.763-.81 0-1.602-.338-1.998-.651a.815.815 0 0 0-1.028.005 9.116 9.116 0 0 1-5.639 1.965c-3.375 0-5.863-1.94-6.8-3.085a.82.82 0 0 0-1.182-.104.886.886 0 0 0-.1 1.219c.31.379 3.168 3.7 8.082 3.7 2.867 0 4.98-1.106 6.19-1.967a5.305 5.305 0 0 0 2.474.649c2.988 0 5.33-2.414 5.33-5.494 0-2.537-1.978-5.25-4.95-5.403zm39.372 8.902h1.903V7.297h-1.903v6.762zm6.802-6.969c-.713 0-1.35.298-1.738.784h-.02V7.3h-1.903v6.758h1.903v-3.29c0-1.314.69-1.88 1.476-1.88.545 0 1.375.357 1.375 1.686v3.48H66.9V10.43c0-2.273-1.521-3.339-2.997-3.339zm-5.85-2.972c-.615 0-1.112.514-1.112 1.147 0 .634.497 1.148 1.111 1.148s1.112-.514 1.112-1.148c0-.633-.498-1.147-1.112-1.147zm-4.332 6.308l-3.86-5.239c-.398-.54-.778-.706-1.086-.706-.727 0-1.11.453-1.11 1.101v8.474h2.043V8.173l3.86 5.24c.398.54.777.707 1.085.707.729 0 1.11-.453 1.11-1.102V4.545H53.72v5.882zm71.964-2.516h-.021v-.612h-1.902v6.758h1.902V11.01c0-1.28.667-2.01 1.694-2.01h.065V7.09c-.666 0-1.39.277-1.738.82zm-4.267 2.771c0-1.001-.773-1.815-1.724-1.815-.95 0-1.723.814-1.723 1.816 0 1 .773 1.815 1.724 1.815.95 0 1.723-.814 1.723-1.816zm1.77-.002c0 1.978-1.562 3.588-3.493 3.588-1.93 0-3.494-1.61-3.494-3.588 0-1.98 1.564-3.59 3.494-3.59 1.93 0 3.494 1.612 3.494 3.59zm-8.428-5.244h-1.898v1.863h-1.272v1.594h1.272v5.164h1.898V8.892h1.287V7.298h-1.287V5.435zm17.965 4.512c-.192-.579-.729-1.197-1.674-1.197-.669 0-1.324.342-1.62 1.197h3.294zm.53 1.35h-3.87c.235.871.987 1.311 1.639 1.311.66 0 1.156-.236 1.561-.76l1.556.565c-.506 1.028-1.675 1.854-3.1 1.854-1.955 0-3.441-1.76-3.441-3.6 0-1.78 1.452-3.578 3.422-3.578 2.272 0 3.457 1.995 3.485 3.398 0 .641-.42.81-1.252.81zm-21.82.08c0 1.374-1.178 2.962-3.155 2.962-1.562 0-2.744-.99-3.345-1.768l1.744-1.252c.474.495 1.071.866 1.651.866.51 0 .992-.331.992-.808 0-.674-.92-.933-1.922-1.324-1.7-.663-2.225-1.681-2.225-2.882 0-1.445 1.224-2.908 3.108-2.908 1.223 0 2.283.75 2.957 1.605l-1.609 1.162c-.506-.485-.943-.659-1.425-.659-.696 0-.98.433-.98.783 0 .732.972.95 1.927 1.322 1.93.748 2.284 1.858 2.284 2.9h-.001z"
        fill="currentColor"
        fill-rule="nonzero"
        mask="url(#b)"
      ></path>
    </svg>
  ),
  nitendoStoreLarge: (
    <svg
      viewBox="0 0 135 18"
      xmlns="http://www.w3.org/2000/svg"
      class="PromoBladeAstyles__StoreLogo-sc-qk7pgj-3 brtoDB"
      width="100%"
      role="presentation"
      alt=""
      data-testid="MyNintendoStoreLogoIcon"
      color="currentColor"
      size="56"
    >
      <path
        d="M76.974 9.947c-.19-.58-.727-1.197-1.672-1.197-.67 0-1.337.342-1.632 1.197h3.304zm1.781.54c0 .641-.42.81-1.25.81h-3.862c.187.86.965 1.313 1.632 1.313.658 0 1.155-.24 1.561-.761l1.553.564c-.505 1.03-1.674 1.854-3.098 1.854-1.956 0-3.44-1.76-3.44-3.6 0-1.78 1.45-3.578 3.422-3.578 2.27 0 3.455 1.996 3.483 3.398zm4.316-3.397c-.713 0-1.35.298-1.738.784h-.02V7.3h-1.904v6.758h1.903v-3.29c0-1.314.692-1.88 1.477-1.88.545 0 1.375.357 1.375 1.686v3.48h1.903V10.43c0-2.273-1.52-3.339-2.996-3.339zM70.409 5.435H68.51v1.863h-1.27v1.593h1.27v5.165h1.9V8.891h1.286V7.298H70.41V5.435h-.001zm29.304 5.246c0-1.001-.773-1.816-1.724-1.816-.95 0-1.723.815-1.723 1.816 0 1.002.773 1.817 1.724 1.817.95 0 1.724-.815 1.724-1.817h-.001zm1.771-.002c0 1.978-1.564 3.588-3.494 3.588-1.931 0-3.494-1.61-3.494-3.588 0-1.98 1.563-3.59 3.494-3.59 1.93 0 3.494 1.612 3.494 3.59zm1.184 3.093l-.147-.518h-.267v.805h.183l-.006-.603.169.603h.132l.168-.603-.006.603h.183v-.805h-.268l-.141.518zM91.96 10.677c0-1.022-.736-1.83-1.732-1.83-.995 0-1.755.822-1.755 1.83s.76 1.829 1.755 1.829c.996 0 1.732-.808 1.732-1.829zm-.01-6.133h1.904v9.515H91.95v-.5h-.032c-.15.231-.854.708-1.753.708-1.877 0-3.458-1.617-3.458-3.59 0-1.973 1.58-3.588 3.458-3.588.9 0 1.602.474 1.753.705h.032v-3.25zM35.933 4.48c-.484 0-1.023.197-1.45 1.202-.292.69-2.296 5.375-2.296 5.375h-.038l-2.298-5.378c-.427-1.002-.994-1.198-1.45-1.198-.661 0-1.276.451-1.276 1.53v8.046h2.042V8.753h.04l1.903 4.464c.33.773.697.902 1.057.902.361 0 .729-.129 1.058-.902l1.903-4.464h.04v5.303h2.042V6.018c0-1.079-.56-1.54-1.277-1.54zm65.714 8.955h.153v.625h.2v-.625h.153v-.18h-.506v.18zm-59.967-1.95L40.086 7.29h-2.128l2.844 6.63c-.182.876-.727 1.218-1.488 1.218h-.279v1.687h.362c1.454 0 2.207-.269 2.66-1.412.112-.28 3.2-8.123 3.2-8.123h-2.143l-1.434 4.194zM17.73 5.156C16.182 2.24 13.406.515 10.203.515c-3.769 0-7.667 2.59-7.667 6.922 0 3.042 2.526 4.287 2.635 4.338a.825.825 0 0 0 1.091-.376l1.445-2.78 1.044 2.113c.144.29.431.472.747.472s.604-.182.747-.472l1.039-2.1 1.413 2.762a.826.826 0 0 0 1.132.362.88.88 0 0 0 .35-1.17l-2.166-4.237a.846.846 0 0 0-.749-.461.835.835 0 0 0-.74.472L9.498 8.435 8.473 6.36a.835.835 0 0 0-.739-.472.837.837 0 0 0-.748.456l-1.762 3.39C4.757 9.3 4.213 8.557 4.213 7.437c0-3.249 3.045-5.191 5.99-5.191 2.715 0 5.054 1.55 6.256 4.145.148.32.47.513.813.49.08-.005.11-.003.125-.003.028.002.049.002.066.002 2.086 0 3.54 1.94 3.54 3.68 0 2.11-1.605 3.763-3.652 3.763-.81 0-1.602-.338-1.998-.651a.815.815 0 0 0-1.028.005 9.116 9.116 0 0 1-5.639 1.965c-3.375 0-5.863-1.94-6.8-3.085a.82.82 0 0 0-1.182-.104.886.886 0 0 0-.1 1.219c.31.379 3.168 3.7 8.082 3.7 2.867 0 4.98-1.106 6.19-1.967a5.305 5.305 0 0 0 2.474.649c2.988 0 5.33-2.414 5.33-5.494 0-2.537-1.978-5.25-4.95-5.403zm39.372 8.902h1.903V7.297h-1.903v6.762zm6.802-6.969c-.713 0-1.35.298-1.738.784h-.02V7.3h-1.903v6.758h1.903v-3.29c0-1.314.69-1.88 1.476-1.88.545 0 1.375.357 1.375 1.686v3.48H66.9V10.43c0-2.273-1.521-3.339-2.997-3.339zm-5.85-2.972c-.615 0-1.112.514-1.112 1.147 0 .634.497 1.148 1.111 1.148s1.112-.514 1.112-1.148c0-.633-.498-1.147-1.112-1.147zm-4.332 6.308l-3.86-5.239c-.398-.54-.778-.706-1.086-.706-.727 0-1.11.453-1.11 1.101v8.474h2.043V8.173l3.86 5.24c.398.54.777.707 1.085.707.729 0 1.11-.453 1.11-1.102V4.545H53.72v5.882zm71.964-2.516h-.021v-.612h-1.902v6.758h1.902V11.01c0-1.28.667-2.01 1.694-2.01h.065V7.09c-.666 0-1.39.277-1.738.82zm-4.267 2.771c0-1.001-.773-1.815-1.724-1.815-.95 0-1.723.814-1.723 1.816 0 1 .773 1.815 1.724 1.815.95 0 1.723-.814 1.723-1.816zm1.77-.002c0 1.978-1.562 3.588-3.493 3.588-1.93 0-3.494-1.61-3.494-3.588 0-1.98 1.564-3.59 3.494-3.59 1.93 0 3.494 1.612 3.494 3.59zm-8.428-5.244h-1.898v1.863h-1.272v1.594h1.272v5.164h1.898V8.892h1.287V7.298h-1.287V5.435zm17.965 4.512c-.192-.579-.729-1.197-1.674-1.197-.669 0-1.324.342-1.62 1.197h3.294zm.53 1.35h-3.87c.235.871.987 1.311 1.639 1.311.66 0 1.156-.236 1.561-.76l1.556.565c-.506 1.028-1.675 1.854-3.1 1.854-1.955 0-3.441-1.76-3.441-3.6 0-1.78 1.452-3.578 3.422-3.578 2.272 0 3.457 1.995 3.485 3.398 0 .641-.42.81-1.252.81zm-21.82.08c0 1.374-1.178 2.962-3.155 2.962-1.562 0-2.744-.99-3.345-1.768l1.744-1.252c.474.495 1.071.866 1.651.866.51 0 .992-.331.992-.808 0-.674-.92-.933-1.922-1.324-1.7-.663-2.225-1.681-2.225-2.882 0-1.445 1.224-2.908 3.108-2.908 1.223 0 2.283.75 2.957 1.605l-1.609 1.162c-.506-.485-.943-.659-1.425-.659-.696 0-.98.433-.98.783 0 .732.972.95 1.927 1.322 1.93.748 2.284 1.858 2.284 2.9h-.001z"
        fill="currentColor"
        fill-rule="nonzero"
        mask="url(#b)"
      ></path>
    </svg>
  ),
  handle: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="ControllerIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M27.136 12.803a1.187 1.187 0 1 1 0-2.373 1.187 1.187 0 0 1 0 2.373zm-2.506-2.17a1.186 1.186 0 1 1 0-2.372 1.186 1.186 0 0 1 0 2.372zm0 4.338a1.183 1.183 0 0 1-.837-2.022 1.183 1.183 0 0 1 2.022.838c0 .654-.53 1.184-1.185 1.184zm-2.507-2.168a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37zm-1.903 5.692a1.805 1.805 0 1 1-.002-3.61 1.805 1.805 0 0 1 .002 3.61zm-6.805-1.805v.513a.255.255 0 0 1-.255.253c-.411-.002-.822-.003-1.233-.002a.1.1 0 0 0-.09.047.12.12 0 0 0-.015.059v1.233c0 .14-.112.253-.252.254h-1.027a.254.254 0 0 1-.253-.254l.001-1.233a.115.115 0 0 0-.017-.059.09.09 0 0 0-.087-.047c-.412 0-.824 0-1.234.002a.253.253 0 0 1-.253-.253v-1.028c0-.14.113-.252.253-.252l1.234.002a.108.108 0 0 0 .053-.015.093.093 0 0 0 .051-.09l-.001-1.235c0-.14.113-.253.253-.253h1.027c.14 0 .253.114.253.253l-.001 1.234c0 .028.01.055.03.075a.1.1 0 0 0 .075.03l1.233-.001c.14 0 .254.112.255.252v.515zm-6.4-3.269a1.804 1.804 0 1 1 0-3.608 1.804 1.804 0 0 1 0 3.608zm24.949 8.973c-.174-2.068-.594-4.118-.933-6.163-.335-2.022-.674-4.07-1.194-6.053a5.393 5.393 0 0 0-1.079-2.342.872.872 0 0 0-.209-.168c-.163-.254-.326-.89-.487-1.147-.813-1.227-2.611-1.557-3.946-1.725a4.29 4.29 0 0 0-2.24.06c-.417.166-.827.738-1.238.92-.256-.006-.51-.01-.762-.017a184.9 184.9 0 0 0-6.45-.023c-.685.008-1.379.013-2.075.028-.403-.177-.805-.746-1.213-.907a4.268 4.268 0 0 0-2.24-.06c-1.336.167-3.133.497-3.946 1.724-.16.256-.324.893-.487 1.147a.94.94 0 0 0-.21.168 3.594 3.594 0 0 0-.72 1.163 38.585 38.585 0 0 0-1.342 5.988C.83 17.023.456 19.076.188 21.126c-.231 1.777-.512 4.005.93 5.377.613.621 1.49.907 2.351.766a3.268 3.268 0 0 0 2.058-1.797c.489-.833.902-1.705 1.326-2.573.398-.816.847-1.933 1.851-2.112a10.19 10.19 0 0 1 1.755-.046h11.786c.849-.15 1.71.193 2.22.887a26.38 26.38 0 0 1 1.465 2.829c.81 1.551 1.999 3.54 4.066 2.644 1.864-.807 2.118-2.922 1.968-4.707z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  handleLarge: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      role="presentation"
      alt=""
      data-testid="ControllerIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M27.136 12.803a1.187 1.187 0 1 1 0-2.373 1.187 1.187 0 0 1 0 2.373zm-2.506-2.17a1.186 1.186 0 1 1 0-2.372 1.186 1.186 0 0 1 0 2.372zm0 4.338a1.183 1.183 0 0 1-.837-2.022 1.183 1.183 0 0 1 2.022.838c0 .654-.53 1.184-1.185 1.184zm-2.507-2.168a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37zm-1.903 5.692a1.805 1.805 0 1 1-.002-3.61 1.805 1.805 0 0 1 .002 3.61zm-6.805-1.805v.513a.255.255 0 0 1-.255.253c-.411-.002-.822-.003-1.233-.002a.1.1 0 0 0-.09.047.12.12 0 0 0-.015.059v1.233c0 .14-.112.253-.252.254h-1.027a.254.254 0 0 1-.253-.254l.001-1.233a.115.115 0 0 0-.017-.059.09.09 0 0 0-.087-.047c-.412 0-.824 0-1.234.002a.253.253 0 0 1-.253-.253v-1.028c0-.14.113-.252.253-.252l1.234.002a.108.108 0 0 0 .053-.015.093.093 0 0 0 .051-.09l-.001-1.235c0-.14.113-.253.253-.253h1.027c.14 0 .253.114.253.253l-.001 1.234c0 .028.01.055.03.075a.1.1 0 0 0 .075.03l1.233-.001c.14 0 .254.112.255.252v.515zm-6.4-3.269a1.804 1.804 0 1 1 0-3.608 1.804 1.804 0 0 1 0 3.608zm24.949 8.973c-.174-2.068-.594-4.118-.933-6.163-.335-2.022-.674-4.07-1.194-6.053a5.393 5.393 0 0 0-1.079-2.342.872.872 0 0 0-.209-.168c-.163-.254-.326-.89-.487-1.147-.813-1.227-2.611-1.557-3.946-1.725a4.29 4.29 0 0 0-2.24.06c-.417.166-.827.738-1.238.92-.256-.006-.51-.01-.762-.017a184.9 184.9 0 0 0-6.45-.023c-.685.008-1.379.013-2.075.028-.403-.177-.805-.746-1.213-.907a4.268 4.268 0 0 0-2.24-.06c-1.336.167-3.133.497-3.946 1.724-.16.256-.324.893-.487 1.147a.94.94 0 0 0-.21.168 3.594 3.594 0 0 0-.72 1.163 38.585 38.585 0 0 0-1.342 5.988C.83 17.023.456 19.076.188 21.126c-.231 1.777-.512 4.005.93 5.377.613.621 1.49.907 2.351.766a3.268 3.268 0 0 0 2.058-1.797c.489-.833.902-1.705 1.326-2.573.398-.816.847-1.933 1.851-2.112a10.19 10.19 0 0 1 1.755-.046h11.786c.849-.15 1.71.193 2.22.887a26.38 26.38 0 0 1 1.465 2.829c.81 1.551 1.999 3.54 4.066 2.644 1.864-.807 2.118-2.922 1.968-4.707z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  handleFullWidth: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      role="presentation"
      alt=""
      data-testid="ControllerIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M27.136 12.803a1.187 1.187 0 1 1 0-2.373 1.187 1.187 0 0 1 0 2.373zm-2.506-2.17a1.186 1.186 0 1 1 0-2.372 1.186 1.186 0 0 1 0 2.372zm0 4.338a1.183 1.183 0 0 1-.837-2.022 1.183 1.183 0 0 1 2.022.838c0 .654-.53 1.184-1.185 1.184zm-2.507-2.168a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37zm-1.903 5.692a1.805 1.805 0 1 1-.002-3.61 1.805 1.805 0 0 1 .002 3.61zm-6.805-1.805v.513a.255.255 0 0 1-.255.253c-.411-.002-.822-.003-1.233-.002a.1.1 0 0 0-.09.047.12.12 0 0 0-.015.059v1.233c0 .14-.112.253-.252.254h-1.027a.254.254 0 0 1-.253-.254l.001-1.233a.115.115 0 0 0-.017-.059.09.09 0 0 0-.087-.047c-.412 0-.824 0-1.234.002a.253.253 0 0 1-.253-.253v-1.028c0-.14.113-.252.253-.252l1.234.002a.108.108 0 0 0 .053-.015.093.093 0 0 0 .051-.09l-.001-1.235c0-.14.113-.253.253-.253h1.027c.14 0 .253.114.253.253l-.001 1.234c0 .028.01.055.03.075a.1.1 0 0 0 .075.03l1.233-.001c.14 0 .254.112.255.252v.515zm-6.4-3.269a1.804 1.804 0 1 1 0-3.608 1.804 1.804 0 0 1 0 3.608zm24.949 8.973c-.174-2.068-.594-4.118-.933-6.163-.335-2.022-.674-4.07-1.194-6.053a5.393 5.393 0 0 0-1.079-2.342.872.872 0 0 0-.209-.168c-.163-.254-.326-.89-.487-1.147-.813-1.227-2.611-1.557-3.946-1.725a4.29 4.29 0 0 0-2.24.06c-.417.166-.827.738-1.238.92-.256-.006-.51-.01-.762-.017a184.9 184.9 0 0 0-6.45-.023c-.685.008-1.379.013-2.075.028-.403-.177-.805-.746-1.213-.907a4.268 4.268 0 0 0-2.24-.06c-1.336.167-3.133.497-3.946 1.724-.16.256-.324.893-.487 1.147a.94.94 0 0 0-.21.168 3.594 3.594 0 0 0-.72 1.163 38.585 38.585 0 0 0-1.342 5.988C.83 17.023.456 19.076.188 21.126c-.231 1.777-.512 4.005.93 5.377.613.621 1.49.907 2.351.766a3.268 3.268 0 0 0 2.058-1.797c.489-.833.902-1.705 1.326-2.573.398-.816.847-1.933 1.851-2.112a10.19 10.19 0 0 1 1.755-.046h11.786c.849-.15 1.71.193 2.22.887a26.38 26.38 0 0 1 1.465 2.829c.81 1.551 1.999 3.54 4.066 2.644 1.864-.807 2.118-2.922 1.968-4.707z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  tshirt: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="TShirtIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M7.735 29.333V11.101l-4.428 2.82L0 8.282l6.704-4.705a4.913 4.913 0 0 1 2.825-.891c.922 0 2.034-.005 2.66-.018.415 1.682 2.402 2.107 3.81 2.107 1.41 0 3.397-.425 3.812-2.107.626.013 1.738.019 2.66.018a4.906 4.906 0 0 1 2.825.891L32 8.281l-3.307 5.64-4.427-2.82v18.232H7.735z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  tshirtFullWidth: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      role="presentation"
      alt=""
      data-testid="TShirtIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M7.735 29.333V11.101l-4.428 2.82L0 8.282l6.704-4.705a4.913 4.913 0 0 1 2.825-.891c.922 0 2.034-.005 2.66-.018.415 1.682 2.402 2.107 3.81 2.107 1.41 0 3.397-.425 3.812-2.107.626.013 1.738.019 2.66.018a4.906 4.906 0 0 1 2.825.891L32 8.281l-3.307 5.64-4.427-2.82v18.232H7.735z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  charactor: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      role="presentation"
      alt=""
      data-testid="CharacterIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M29.399 25.007a5.387 5.387 0 0 0-.539-.329 1.978 1.978 0 0 0-1.844-1.78 2.688 2.688 0 0 0-2.383 1.43.834.834 0 0 0-1.218.222 20.438 20.438 0 0 0-2.64-1.37 6.13 6.13 0 0 0 .37-3.363c.58.065 1.117.116 1.27.12.347.02.692-.053 1-.211.632-.352 1.238-.75 1.813-1.189a.769.769 0 0 0 1.138-.814 3.835 3.835 0 0 0 2.865-2.689c.244-.795.047-1.342-.258-1.53a1.045 1.045 0 0 0-.975-1.343.963.963 0 0 0-1.241-.945c-.055-.397-.456-.644-.984-.546a2.55 2.55 0 0 0-1.647 1.42.916.916 0 0 0-1.11.15 2.786 2.786 0 0 0-.233 2.614c-.397-.14-.968.41-.606 1.097l-.347.215c-.171.11-.171.11-.562.078a10.434 10.434 0 0 1-2.21-.64 2.688 2.688 0 0 0 2.027-1.465.812.812 0 0 0 .597-1.159c.605-.206.944-.848.773-1.463a2.574 2.574 0 0 0 1.989-1.19c.992-1.84-.385-3.705-2.043-3.261a4.432 4.432 0 0 0-1.89 1.066c-.268-.679-.57-1.354-.808-1.909.902-.561 3.233-3.42 2.73-3.966-.493-.535-2.798.185-3.842.805A5.003 5.003 0 0 0 17.372.72c-.87-.87-2.28-1.046-3.887 0A10.588 10.588 0 0 0 9.48 7.816c-3.033 1.276-2.201 4.364 1.046 4.895.151.452.44.846.828 1.124-.78.219-.473 1.068.296 1.073-.944.073-1.88.22-2.802.438a.893.893 0 0 0-1.594.024 3.87 3.87 0 0 0-2.708-.288 2.192 2.192 0 0 0-1.826 2.44 1.252 1.252 0 0 0 .126 1.781.975.975 0 0 0 .757 1.458c-.183.918 1.05 1.592 2.657.532 1.05.977 2.412.052 2.599-1.652.457.248 1.007-.012 1.066-.689a19.002 19.002 0 0 1 2.963-.433c0 .493-.091.981-.27 1.44a3.973 3.973 0 0 0-.444 4.064.67.67 0 0 1-.223.187 14.946 14.946 0 0 0-.738-.363.681.681 0 0 0-.984-.609 1.634 1.634 0 0 0-2.02-.76 2.25 2.25 0 0 0-.649-.177.52.52 0 0 0-.548.231 7.972 7.972 0 0 0-.818 1.792.288.288 0 0 0 .084.333c.074.062.154.117.24.162a9.789 9.789 0 0 0-2.058 4.078c-.08.359-.045.583.126.691.183.123.38.226.585.307.196.98 1.08 1.67 2.079 1.622a3.013 3.013 0 0 0 2.417-2.06c.272.003.53-.12.698-.335a6.07 6.07 0 0 0 3.456.771 5.93 5.93 0 0 0 3.13-2.516 22.596 22.596 0 0 1 5.152 2.5c.054.52.51.903 1.03.867.36.859 1.445 1.358 2.015 1.007.223.083.45.154.68.211.328.077.377.04.526-.14.364-.457.667-.958.9-1.492.114-.259.125-.423.014-.546a1.667 1.667 0 0 0-.234-.193 8.894 8.894 0 0 0 2.529-4.01c.07-.329.013-.44-.164-.575"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  charactorFullWidth: (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      role="presentation"
      alt=""
      data-testid="CharacterIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M29.399 25.007a5.387 5.387 0 0 0-.539-.329 1.978 1.978 0 0 0-1.844-1.78 2.688 2.688 0 0 0-2.383 1.43.834.834 0 0 0-1.218.222 20.438 20.438 0 0 0-2.64-1.37 6.13 6.13 0 0 0 .37-3.363c.58.065 1.117.116 1.27.12.347.02.692-.053 1-.211.632-.352 1.238-.75 1.813-1.189a.769.769 0 0 0 1.138-.814 3.835 3.835 0 0 0 2.865-2.689c.244-.795.047-1.342-.258-1.53a1.045 1.045 0 0 0-.975-1.343.963.963 0 0 0-1.241-.945c-.055-.397-.456-.644-.984-.546a2.55 2.55 0 0 0-1.647 1.42.916.916 0 0 0-1.11.15 2.786 2.786 0 0 0-.233 2.614c-.397-.14-.968.41-.606 1.097l-.347.215c-.171.11-.171.11-.562.078a10.434 10.434 0 0 1-2.21-.64 2.688 2.688 0 0 0 2.027-1.465.812.812 0 0 0 .597-1.159c.605-.206.944-.848.773-1.463a2.574 2.574 0 0 0 1.989-1.19c.992-1.84-.385-3.705-2.043-3.261a4.432 4.432 0 0 0-1.89 1.066c-.268-.679-.57-1.354-.808-1.909.902-.561 3.233-3.42 2.73-3.966-.493-.535-2.798.185-3.842.805A5.003 5.003 0 0 0 17.372.72c-.87-.87-2.28-1.046-3.887 0A10.588 10.588 0 0 0 9.48 7.816c-3.033 1.276-2.201 4.364 1.046 4.895.151.452.44.846.828 1.124-.78.219-.473 1.068.296 1.073-.944.073-1.88.22-2.802.438a.893.893 0 0 0-1.594.024 3.87 3.87 0 0 0-2.708-.288 2.192 2.192 0 0 0-1.826 2.44 1.252 1.252 0 0 0 .126 1.781.975.975 0 0 0 .757 1.458c-.183.918 1.05 1.592 2.657.532 1.05.977 2.412.052 2.599-1.652.457.248 1.007-.012 1.066-.689a19.002 19.002 0 0 1 2.963-.433c0 .493-.091.981-.27 1.44a3.973 3.973 0 0 0-.444 4.064.67.67 0 0 1-.223.187 14.946 14.946 0 0 0-.738-.363.681.681 0 0 0-.984-.609 1.634 1.634 0 0 0-2.02-.76 2.25 2.25 0 0 0-.649-.177.52.52 0 0 0-.548.231 7.972 7.972 0 0 0-.818 1.792.288.288 0 0 0 .084.333c.074.062.154.117.24.162a9.789 9.789 0 0 0-2.058 4.078c-.08.359-.045.583.126.691.183.123.38.226.585.307.196.98 1.08 1.67 2.079 1.622a3.013 3.013 0 0 0 2.417-2.06c.272.003.53-.12.698-.335a6.07 6.07 0 0 0 3.456.771 5.93 5.93 0 0 0 3.13-2.516 22.596 22.596 0 0 1 5.152 2.5c.054.52.51.903 1.03.867.36.859 1.445 1.358 2.015 1.007.223.083.45.154.68.211.328.077.377.04.526-.14.364-.457.667-.958.9-1.492.114-.259.125-.423.014-.546a1.667 1.667 0 0 0-.234-.193 8.894 8.894 0 0 0 2.529-4.01c.07-.329.013-.44-.164-.575"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  sales: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="18"
      role="presentation"
      alt=""
      data-testid="SalesTagIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M16.5.4c.2-.3.6-.4 1-.4l9.4.2c.4 0 .7.2 1 .4l3.5 3.5c.3.3.4.6.4 1l.2 9.4c0 .4-.1.8-.4 1.1l-16 16c-.6.6-1.5.6-2.1 0L.4 18.5c-.6-.6-.6-1.5 0-2.1L16.5.4zm6.7 4.1c-1.2 1.2-1.2 3.1 0 4.3s3.1 1.2 4.3 0c1.2-1.2 1.2-3.1 0-4.3-1.2-1.2-3.2-1.2-4.3 0z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  salesFullWidth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      role="presentation"
      alt=""
      data-testid="SalesTagIcon"
      size="18"
      color="currentColor"
    >
      <path
        d="M16.5.4c.2-.3.6-.4 1-.4l9.4.2c.4 0 .7.2 1 .4l3.5 3.5c.3.3.4.6.4 1l.2 9.4c0 .4-.1.8-.4 1.1l-16 16c-.6.6-1.5.6-2.1 0L.4 18.5c-.6-.6-.6-1.5 0-2.1L16.5.4zm6.7 4.1c-1.2 1.2-1.2 3.1 0 4.3s3.1 1.2 4.3 0c1.2-1.2 1.2-3.1 0-4.3-1.2-1.2-3.2-1.2-4.3 0z"
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  ),
  loudSpeaker: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 34.22"
      width="42"
      role="presentation"
      alt=""
      data-testid="MegaphoneDarkIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M29.55 0a1.91 1.91 0 0 1 1.93 1.87V10h.21a4.87 4.87 0 0 1 4.82 4.89v.2A4.87 4.87 0 0 1 31.69 20h-.21v8.1a1.91 1.91 0 0 1-1.93 1.87L19 22.45h-4.61l1.13 8.62a3.24 3.24 0 0 1-3.31 3.15h-1.66a3.24 3.24 0 0 1-3.31-3.15l-1.13-8.62H3.4A3.59 3.59 0 0 1 0 18.71v-7.49a3.6 3.6 0 0 1 3.4-3.74H18.95zm8.2 20.81a.6.6 0 0 1 .85.05l4.12 4.61a.62.62 0 0 1 0 .86.59.59 0 0 1-.41.16.6.6 0 0 1-.44-.2l-4.17-4.61a.63.63 0 0 1 .05-.87zm-6.06-8.39h-.21v5.09h.21a2.42 2.42 0 0 0 2.41-2.44v-.2a2.43 2.43 0 0 0-2.41-2.45zM43.4 14a.62.62 0 0 1 0 1.23h-4.67a.62.62 0 0 1 0-1.23h4.67zM41.83 3a.59.59 0 0 1 .85 0 .62.62 0 0 1 0 .86l-4.08 4.6a.62.62 0 0 1-.45.2.61.61 0 0 1-.4-.16.63.63 0 0 1 0-.87z"
        // style="fill: rgb(72, 72, 72); fill-rule: evenodd;"
      ></path>
    </svg>
  ),
  calculatorLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="42"
      role="presentation"
      alt=""
      data-testid="CalendarIcon"
      size="42"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M21.8 19.1h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm0 8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm1.6-20.3h1.5c.5 0 .9-.4.9-.9v-5c0-.5-.4-.9-.9-.9h-1.5c-.5 0-.9.4-.9.9v5c0 .5.4.9.9.9zm-16.3 0h1.5c.5 0 .9-.4.9-.9v-5c0-.5-.4-.9-.9-.9H7.1c-.5 0-.9.4-.9.9v5c0 .5.4.9.9.9zm6.1 20.3h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9z"
      ></path>
      <path
        fill="currentColor"
        d="M29.5 4.3H27v2.2c0 1.2-.9 2.1-2.1 2.1h-1.5c-1.2 0-2.1-1-2.1-2.1V4.3H10.7v2.2c0 1.2-.9 2.1-2.1 2.1H7.1C5.9 8.6 5 7.6 5 6.5V4.3H2.5C1.1 4.3 0 5.4 0 6.7V29c0 1.4 1.1 2.5 2.5 2.5h27c1.4 0 2.5-1.1 2.5-2.5V6.7c0-1.3-1.1-2.4-2.5-2.4zm0 24.7h-27V10.4h27V29z"
      ></path>
      <path
        fill="currentColor"
        d="M13.2 19.1h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm-8.6 8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9H4.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9zm0-8.6h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9H4.6c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9z"
      ></path>
    </svg>
  ),
  compareLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 65.62 43.47"
      width="42"
      role="presentation"
      alt=""
      data-testid="CompareArrowsIcon"
      size="42"
      color="currentColor"
    >
      <path d="M33.64 14.63L19.01 29.25l-3.65-3.66 8.41-8.41L0 17.31v-5.37l23.77.13-8.41-8.41L19.01 0l14.63 14.63zM31.98 28.84L46.6 43.47l3.66-3.66-8.41-8.41 23.77.12v-5.36l-23.77.13 8.41-8.41-3.66-3.66-14.62 14.62z"></path>
    </svg>
  ),
  onlineServiceLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="42"
      role="presentation"
      alt=""
      data-testid="NsoIcon"
      size="42"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M0 0v32h32V0zm8.785 9.232a3.7 3.7 0 0 1 3.7-3.7h3.154a.106.106 0 0 1 .106.106v14.218a.106.106 0 0 1-.106.106h-3.154a3.7 3.7 0 0 1-3.7-3.7zM6.767 26.596a2.034 2.034 0 1 1 2.064-2.034 2.05 2.05 0 0 1-2.064 2.034zm6.473-.124h-.677l-2.032-2.547v2.547h-.773v-3.82h.77l1.9 2.464v-2.464h.812zm4.025 0H14.35v-3.82h.82v3.075h2.094zm1.616 0h-.82v-3.82h.82zm-1.586-6.51a.105.105 0 0 1-.106-.106V5.626a.093.093 0 0 1 .094-.094h2.232a3.7 3.7 0 0 1 3.7 3.7v7.03a3.7 3.7 0 0 1-3.7 3.7zm6.178 6.51h-.676l-2.033-2.547v2.547h-.772v-3.82h.769l1.901 2.464v-2.464h.811zm4.27-3.075H25.41v.76h2.22v.707h-2.22v.863h2.333v.745H24.59v-3.82h3.154z"
      ></path>
      <path
        fill="currentColor"
        d="M6.767 23.306a1.257 1.257 0 1 0 1.214 1.256 1.236 1.236 0 0 0-1.214-1.256zm5.718-4.508h2.097V6.696h-2.097A2.536 2.536 0 0 0 9.95 9.232v7.03a2.536 2.536 0 0 0 2.536 2.536zm-.097-10.294a1.357 1.357 0 1 1-1.356 1.356 1.357 1.357 0 0 1 1.356-1.356zm7.655 3.506a1.459 1.459 0 1 0 1.46 1.458 1.459 1.459 0 0 0-1.46-1.458z"
      ></path>
    </svg>
  ),
  smileOneLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 27.76"
      width="42"
      role="presentation"
      alt=""
      data-testid="ForKidsIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M45.55,0c-8,0-14.46,6.21-14.46,13.88s6.47,13.88,14.46,13.88S60,21.55,60,13.88,53.53,0,45.55,0m0,3.75c5.9,0,10.7,4.55,10.7,10.13S51.45,24,45.55,24,34.84,19.46,34.84,13.88,39.64,3.75,45.55,3.75"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
      <path
        d="M43.66,11.28A1.75,1.75,0,0,1,41.93,13a1.67,1.67,0,0,1-1.74-1.6v-.13A1.74,1.74,0,1,1,43.66,11a1.13,1.13,0,0,1,0,.26m7.09,0A1.77,1.77,0,0,1,49,13a1.66,1.66,0,0,1-1.73-1.59v-.14A1.74,1.74,0,1,1,50.74,11a1.13,1.13,0,0,1,0,.26M45.4,20.39a7,7,0,0,1-5.21-2.32,1,1,0,0,1-.06-1.41.91.91,0,0,1,.21-.18,1.18,1.18,0,0,1,1.67.08l.06.07a4.76,4.76,0,0,0,3.33,1.44,5.06,5.06,0,0,0,3.47-1.44,1.32,1.32,0,0,1,1.73-.15,1.15,1.15,0,0,1,.15,1.59,7.08,7.08,0,0,1-5.35,2.32"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
      <path
        d="M14.45,0C6.47,0,0,6.21,0,13.88S6.47,27.76,14.45,27.76s14.46-6.21,14.46-13.88S22.44,0,14.45,0m0,3.75c5.91,0,10.71,4.55,10.71,10.13S20.36,24,14.45,24,3.75,19.46,3.75,13.88,8.55,3.75,14.45,3.75"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
      <path
        d="M12.57,11.28A1.75,1.75,0,0,1,10.84,13,1.67,1.67,0,0,1,9.1,11.4v-.12a1.67,1.67,0,0,1,1.6-1.74h.14a1.67,1.67,0,0,1,1.73,1.61v.13m7.09,0A1.76,1.76,0,0,1,17.92,13a1.67,1.67,0,0,1-1.74-1.6v-.13a1.74,1.74,0,1,1,3.48,0h0m-5.35,9.12A7,7,0,0,1,9.1,18.07,1,1,0,0,1,9,16.66a.91.91,0,0,1,.21-.18,1.18,1.18,0,0,1,1.67.08l.06.07a4.74,4.74,0,0,0,3.33,1.44,5.06,5.06,0,0,0,3.47-1.44,1.32,1.32,0,0,1,1.73-.15,1.15,1.15,0,0,1,.15,1.59,7.11,7.11,0,0,1-5.35,2.32"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  smileTwoLarge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61.22 42.34"
      width="42"
      role="presentation"
      alt=""
      data-testid="ForParentsIcon"
      size="42"
      color="currentColor"
    >
      <path
        d="M46.32 32.31A7.13 7.13 0 0 1 41 29.94a1.05 1.05 0 0 1 .15-1.62 1.21 1.21 0 0 1 1.77.15 4.76 4.76 0 0 0 3.39 1.47 5.13 5.13 0 0 0 3.54-1.47 1.35 1.35 0 0 1 1.77-.15 1.17 1.17 0 0 1 .15 1.62 7.23 7.23 0 0 1-5.46 2.37M51.78 23A1.79 1.79 0 0 1 50 24.78 1.77 1.77 0 1 1 51.78 23m-7.23 0a1.79 1.79 0 0 1-1.77 1.77A1.77 1.77 0 1 1 44.55 23m12.68 2.8a10.77 10.77 0 0 0-21.53 0 10.68 10.68 0 0 0 10.77 10.49c6-.15 10.76-4.72 10.76-10.48M31 16.67a2.84 2.84 0 0 0-3-2.8 2.92 2.92 0 0 0-3 2.8 2.83 2.83 0 0 0 3 2.8 2.93 2.93 0 0 0 3-2.8m-12 0a2.84 2.84 0 0 0-3-2.8 2.93 2.93 0 0 0-2.95 2.8 2.84 2.84 0 0 0 2.95 2.8 2.93 2.93 0 0 0 3-2.8m3 15.19A12.62 12.62 0 0 0 31 28a2.06 2.06 0 0 0-.15-2.8h-.15a2.1 2.1 0 0 0-2.95.29A8 8 0 0 1 22 28a7.19 7.19 0 0 1-5.61-2.51 2.24 2.24 0 0 0-3-.29 1.93 1.93 0 0 0-.29 2.8v.15a12.12 12.12 0 0 0 8.9 3.71m24.47-20.35c8.11 0 14.75 6.34 14.75 14.16s-6.64 14.16-14.75 14.16a14.53 14.53 0 0 1-9.3-3.25 22.8 22.8 0 0 1-15 5.76C9.88 42.34 0 32.75 0 21.1S9.88 0 22.13 0A22.05 22.05 0 0 1 42 12.24a15.56 15.56 0 0 1 4.43-.73"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  clipSale: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.36 20">
      <path
        d="M7.369 0v20h-.181a2.107 2.107 0 01-1.489-.617L.621 14.305a2.1 2.1 0 01-.616-1.5l.029-5.627a2.109 2.109 0 01.612-1.474L5.699.621A2.104 2.104 0 017.192 0h.177z"
        fill="currentColor"
        fill-rule="evenodd"
      ></path>
    </svg>
  ),
  fb: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="30"
      role="presentation"
      alt=""
      data-testid="FacebookIcon"
      size="30"
      color="currentColor"
    >
      <path
        d="M16 0C7.2 0 0 7.2 0 16c0 8 5.9 14.6 13.5 15.8V20.6H9.4V16h4.1v-3.5c0-4 2.4-6.2 6-6.2 1.8 0 3.6.3 3.6.3v3.9h-2c-2 0-2.6 1.2-2.6 2.5v3h4.4l-.7 4.6h-3.7v11.2C26.1 30.6 32 24 32 16c0-8.8-7.2-16-16-16z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  instagram: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="30"
      role="presentation"
      alt=""
      data-testid="InstagramIcon"
      size="30"
      color="currentColor"
    >
      <path
        fill="currentColor"
        d="M24.506 5.514c-.511 0-.949.188-1.335.573-.385.376-.573.845-.573 1.397 0 .51.188.949.573 1.334.376.386.845.574 1.397.574.51 0 .949-.188 1.334-.574.376-.375.574-.823.574-1.334 0-.552-.188-1.011-.574-1.397-.375-.385-.844-.573-1.396-.573z"
      ></path>
      <path
        fill="currentColor"
        d="M31.687 7.213a9.443 9.443 0 0 0-.51-1.689 7.692 7.692 0 0 0-.761-1.49 11.917 11.917 0 0 0-1.084-1.366c-.47-.427-.918-.792-1.366-1.084a7.403 7.403 0 0 0-1.49-.76 21.14 21.14 0 0 0-1.689-.48c-.615-.146-1.345-.24-2.189-.281-.844 0-1.616-.01-2.314-.032C19.586.011 18.158 0 16 0s-3.586.01-4.284.031c-.698.021-1.47.052-2.314.094-.844 0-1.574.073-2.189.219-.615.156-1.178.313-1.689.48-.51.208-.99.469-1.459.76-.469.303-.928.657-1.397 1.084-.427.47-.792.928-1.084 1.397-.291.47-.552.949-.76 1.46-.178.51-.334 1.073-.48 1.688-.146.615-.219 1.345-.219 2.189-.042.844-.073 1.616-.094 2.314C.011 12.414 0 13.842 0 16s.01 3.586.031 4.284c.021.698.052 1.47.094 2.314 0 .844.073 1.574.219 2.189.146.615.313 1.178.48 1.689.208.552.469 1.042.76 1.49.303.448.657.897 1.084 1.366.47.427.928.792 1.397 1.084.459.291.949.552 1.46.76.51.167 1.073.334 1.688.48.615.146 1.345.219 2.189.219.844.042 1.616.073 2.314.094.698.02 2.126.031 4.284.031s3.586-.01 4.284-.031a78.06 78.06 0 0 1 2.314-.032c.844-.041 1.574-.135 2.189-.281a26.634 26.634 0 0 0 1.689-.48 7.692 7.692 0 0 0 1.49-.76c.448-.303.897-.657 1.366-1.084.427-.47.792-.928 1.084-1.397.291-.459.552-.949.76-1.46.22-.51.386-1.073.511-1.688s.209-1.345.25-2.189c0-.844.01-1.616.032-2.314.02-.698.031-2.126.031-4.284v-4.284c0-.698-.02-1.47-.063-2.314a14.798 14.798 0 0 0-.25-2.189zm-2.574 13.008c-.021.657-.052 1.408-.094 2.252-.042.76-.115 1.376-.219 1.845a7.77 7.77 0 0 1-.354 1.146 3.9 3.9 0 0 1-.48.98c-.187.271-.417.563-.667.855a8.21 8.21 0 0 1-.886.667c-.292.188-.615.375-.948.542-.303.084-.678.177-1.147.282-.47.104-1.084.177-1.845.218-.844.042-1.605.073-2.283.094-.677.021-2.074.032-4.19.032s-3.513-.01-4.19-.032c-.678-.02-1.439-.052-2.283-.094-.76-.041-1.376-.114-1.845-.218s-.855-.198-1.146-.282a10.26 10.26 0 0 1-.949-.542 8.21 8.21 0 0 1-.886-.667c-.25-.292-.48-.584-.667-.855a3.435 3.435 0 0 1-.48-.98 6.029 6.029 0 0 1-.354-1.146c-.104-.47-.177-1.084-.219-1.845-.042-.844-.073-1.595-.094-2.251-.02-.657-.031-2.064-.031-4.222 0-2.116.01-3.513.031-4.19.021-.678.052-1.439.094-2.283.042-.76.115-1.376.219-1.845.115-.469.23-.834.354-1.084.125-.386.292-.73.48-1.021.187-.292.417-.574.667-.824.292-.292.594-.542.886-.73.292-.198.605-.354.949-.479.302-.136.677-.25 1.146-.354s1.084-.178 1.845-.22a46.697 46.697 0 0 1 2.283-.062h8.38c.677 0 1.439.021 2.283.063.76.041 1.376.114 1.845.219.469.114.855.229 1.146.354.334.125.657.292.949.48.292.187.594.416.886.667.25.291.48.594.667.886.198.291.355.615.48.948.135.302.25.678.354 1.147s.177 1.084.219 1.845c.042.854.073 1.615.094 2.293.02.677.031 2.074.031 4.19 0 2.158-.01 3.565-.031 4.221z"
      ></path>
      <path
        fill="currentColor"
        d="M15.99 7.797c-2.294 0-4.232.802-5.817 2.387C8.578 11.779 7.786 13.717 7.786 16c0 2.293.792 4.221 2.387 5.816 1.595 1.595 3.523 2.387 5.817 2.387s4.231-.802 5.816-2.387c1.584-1.595 2.376-3.533 2.387-5.816 0-2.293-.803-4.232-2.387-5.816-1.595-1.595-3.523-2.387-5.816-2.387zm3.783 11.987c-1.042 1.032-2.303 1.553-3.783 1.553-1.491 0-2.742-.51-3.784-1.553-1.032-1.043-1.553-2.304-1.553-3.784 0-1.49.51-2.741 1.553-3.784 1.042-1.032 2.303-1.553 3.784-1.553s2.74.521 3.783 1.553c1.032 1.043 1.553 2.304 1.553 3.784 0 1.49-.51 2.741-1.553 3.784z"
      ></path>
    </svg>
  ),
  twitter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="30"
      role="presentation"
      alt=""
      data-testid="TwitterIcon"
      size="30"
      color="currentColor"
    >
      <path
        d="M28.73 9.48v.85C28.75 19 22.16 29 10.11 29A18.65 18.65 0 0 1 .06 26a13.61 13.61 0 0 0 1.56.1 13.2 13.2 0 0 0 8.14-2.81 6.58 6.58 0 0 1-6.12-4.55 6.58 6.58 0 0 0 3-.12 6.54 6.54 0 0 1-5.26-6.42v-.08a6.46 6.46 0 0 0 3 .82 6.57 6.57 0 0 1-2-8.75 18.62 18.62 0 0 0 13.5 6.85A6.56 6.56 0 0 1 27 5.09a13.32 13.32 0 0 0 4.12-1.59 6.56 6.56 0 0 1-2.88 3.62 13 13 0 0 0 3.76-1 13.18 13.18 0 0 1-3.27 3.36z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  youtube: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="30"
      role="presentation"
      alt=""
      data-testid="YoutubeIcon"
      size="30"
      color="currentColor"
    >
      <path
        d="M31.33 8.3a4 4 0 0 0-2.83-2.83C26 4.8 16 4.8 16 4.8s-10 0-12.5.67A4 4 0 0 0 .67 8.3 41.51 41.51 0 0 0 0 16a41.51 41.51 0 0 0 .67 7.7 4 4 0 0 0 2.83 2.83c2.5.67 12.5.67 12.5.67s10 0 12.5-.67a4 4 0 0 0 2.83-2.83A41.51 41.51 0 0 0 32 16a41.51 41.51 0 0 0-.67-7.7zM12.8 20.8v-9.6l8.31 4.8z"
        fill="currentColor"
      ></path>
    </svg>
  ),
};
export default imgs;
